import React, { useEffect, useState, useRef, Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, BarChart3, UserCog, FileText, Bell, ChevronDown, Users, UserPlus, Upload, Link2, Mail, Shield, Search, Filter, MoreVertical, Edit, Trash2, CheckCircle, XCircle, Copy, Download, FileSpreadsheet, AlertCircle, Clock, TrendingUp, Activity, X, ArrowDownAZ, ArrowUpAZ, RotateCcw } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { AIInsightPopover } from '../components/AIInsightPopover';
import { SkillsOverview } from '../components/SkillsOverview';
const STATUS_FILTERS = [{
  value: 'all',
  label: 'All statuses'
}, {
  value: 'pending',
  label: 'Pending'
}, {
  value: 'not_assigned',
  label: 'Not Assigned'
}, {
  value: 'active',
  label: 'Active'
}, {
  value: 'inactive',
  label: 'Inactive'
}, {
  value: 'not_started',
  label: 'Not Started'
}, {
  value: 'completed',
  label: 'Completed'
}];
export function UserManagementPage() {
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [userType, setUserType] = useState<'learners' | 'admins'>('learners');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [selectedCohort, setSelectedCohort] = useState('all');
  const [generatedLink, setGeneratedLink] = useState('');
  const [linkCopied, setLinkCopied] = useState(false);
  const [expandedUserId, setExpandedUserId] = useState<number | null>(null);
  const [tourSelectedUserId, setTourSelectedUserId] = useState<number | null>(null);
  const userMenuRef = useRef<HTMLDivElement>(null);
  const licenseDropdownRef = useRef<HTMLDivElement>(null);
  const departmentDropdownRef = useRef<HTMLDivElement>(null);
  const departmentFilterDropdownRef = useRef<HTMLDivElement>(null);
  const cohortDropdownRef = useRef<HTMLDivElement>(null);
  const cohortFilterDropdownRef = useRef<HTMLDivElement>(null);
  const linkLicenseDropdownRef = useRef<HTMLDivElement>(null);
  const paginationDropdownRef = useRef<HTMLDivElement>(null);
  const actionMenuRefs = useRef<{
    [key: number]: HTMLDivElement | null;
  }>({});
  // Form states
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [department, setDepartment] = useState('');
  const [cohort, setCohort] = useState('');
  const [newDepartmentName, setNewDepartmentName] = useState('');
  const [newCohortName, setNewCohortName] = useState('');
  const [role, setRole] = useState('learner');
  const [selectedLicenses, setSelectedLicenses] = useState<string[]>([]);
  const [isLicenseDropdownOpen, setIsLicenseDropdownOpen] = useState(false);
  const [isDepartmentDropdownOpen, setIsDepartmentDropdownOpen] = useState(false);
  const [isDepartmentFilterDropdownOpen, setIsDepartmentFilterDropdownOpen] = useState(false);
  const [isCohortDropdownOpen, setIsCohortDropdownOpen] = useState(false);
  const [isCohortFilterDropdownOpen, setIsCohortFilterDropdownOpen] = useState(false);
  const [isCreatingDepartment, setIsCreatingDepartment] = useState(false);
  const [isCreatingCohort, setIsCreatingCohort] = useState(false);
  const [isPaginationDropdownOpen, setIsPaginationDropdownOpen] = useState(false);
  const [licenseSearch, setLicenseSearch] = useState('');
  const [addModalStep, setAddModalStep] = useState<'form' | 'confirm'>('form');
  const [acknowledgeChecked, setAcknowledgeChecked] = useState(false);
  const [selectedModalPathways, setSelectedModalPathways] = useState<string[]>([]);
  const [linkLicenses, setLinkLicenses] = useState<string[]>([]);
  const [isLinkLicenseDropdownOpen, setIsLinkLicenseDropdownOpen] = useState(false);
  const [linkLicenseSearch, setLinkLicenseSearch] = useState('');
  const [linkPathways, setLinkPathways] = useState<string[]>([]);
  // New State for Bulk Actions
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [bulkUploadStep, setBulkUploadStep] = useState<'upload' | 'errors'>('upload');
  const [bulkErrorEntries, setBulkErrorEntries] = useState<any[]>([]);
  const [bulkSelectedSkills, setBulkSelectedSkills] = useState<string[]>([]);
  const [bulkSelectedPathways, setBulkSelectedPathways] = useState<string[]>([]);
  const [isBulkSkillDropdownOpen, setIsBulkSkillDropdownOpen] = useState(false);
  const [isBulkPathwayDropdownOpen, setIsBulkPathwayDropdownOpen] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [showNoLicenseToast, setShowNoLicenseToast] = useState(false);
  const [openActionMenuId, setOpenActionMenuId] = useState<number | null>(null);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const mobileFilterRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [sortField, setSortField] = useState<'name' | 'department'>('name');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const [showAddAdminModal, setShowAddAdminModal] = useState(false);
  const [adminModalStep, setAdminModalStep] = useState<'form' | 'confirm'>('form');
  const [adminEntries, setAdminEntries] = useState([{
    firstName: '',
    lastName: '',
    email: ''
  }]);
  const [adminAcknowledge, setAdminAcknowledge] = useState(false);
  const bulkSkillDropdownRef = useRef<HTMLDivElement>(null);
  const bulkPathwayDropdownRef = useRef<HTMLDivElement>(null);
  const licensesRemaining = 25;
  const totalLicenses = 280;
  const noLicensesAvailable = licensesRemaining === 0;
  const availableSkills = ['AI Functionality Beyond the Hype', 'Active and Empathetic Listening', 'DEI: Employee Relations and Conflict Resolution', 'Developing EQ and Empathy', 'EQ for the Workplace', 'Effective Communication'];
  const availablePathways = ['Leadership Essentials', 'Technical Foundations', 'Communication Mastery'];
  const [departments, setDepartments] = useState(['Marketing', 'Human Resources', 'IT', 'Sales', 'Finance', 'Operations']);
  const [cohorts, setCohorts] = useState(['2024 Q1 Onboarding', 'Leadership Track', 'Sales Enablement', 'Technical Upskilling']);
  const pathwayData = [{
    name: 'Leadership Essentials',
    skillCount: 3
  }, {
    name: 'DEI Fundamentals',
    skillCount: 2
  }, {
    name: 'Technical Foundations',
    skillCount: 4
  }, {
    name: 'Communication Mastery',
    skillCount: 3
  }];
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
    };
    if (isUserMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen]);
  // Close license dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (licenseDropdownRef.current && !licenseDropdownRef.current.contains(event.target as Node)) {
        setIsLicenseDropdownOpen(false);
      }
      if (departmentDropdownRef.current && !departmentDropdownRef.current.contains(event.target as Node)) {
        setIsDepartmentDropdownOpen(false);
        setIsCreatingDepartment(false);
      }
      if (departmentFilterDropdownRef.current && !departmentFilterDropdownRef.current.contains(event.target as Node)) {
        setIsDepartmentFilterDropdownOpen(false);
      }
      if (cohortDropdownRef.current && !cohortDropdownRef.current.contains(event.target as Node)) {
        setIsCohortDropdownOpen(false);
        setIsCreatingCohort(false);
      }
      if (cohortFilterDropdownRef.current && !cohortFilterDropdownRef.current.contains(event.target as Node)) {
        setIsCohortFilterDropdownOpen(false);
      }
      if (linkLicenseDropdownRef.current && !linkLicenseDropdownRef.current.contains(event.target as Node)) {
        setIsLinkLicenseDropdownOpen(false);
      }
      if (bulkSkillDropdownRef.current && !bulkSkillDropdownRef.current.contains(event.target as Node)) {
        setIsBulkSkillDropdownOpen(false);
      }
      if (bulkPathwayDropdownRef.current && !bulkPathwayDropdownRef.current.contains(event.target as Node)) {
        setIsBulkPathwayDropdownOpen(false);
      }
      // Close action menu if clicking outside
      if (openActionMenuId !== null) {
        const menuRef = actionMenuRefs.current[openActionMenuId];
        if (menuRef && !menuRef.contains(event.target as Node)) {
          setOpenActionMenuId(null);
        }
      }
      // Close mobile filter dropdown if clicking outside
      if (mobileFilterRef.current && !mobileFilterRef.current.contains(event.target as Node)) {
        setIsMobileFilterOpen(false);
      }
      if (paginationDropdownRef.current && !paginationDropdownRef.current.contains(event.target as Node)) {
        setIsPaginationDropdownOpen(false);
      }
    };
    if (isLicenseDropdownOpen || isDepartmentDropdownOpen || isDepartmentFilterDropdownOpen || isCohortDropdownOpen || isCohortFilterDropdownOpen || isLinkLicenseDropdownOpen || isBulkSkillDropdownOpen || isBulkPathwayDropdownOpen || openActionMenuId !== null || isMobileFilterOpen || isPaginationDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLicenseDropdownOpen, isDepartmentDropdownOpen, isDepartmentFilterDropdownOpen, isCohortDropdownOpen, isCohortFilterDropdownOpen, isLinkLicenseDropdownOpen, isBulkSkillDropdownOpen, isBulkPathwayDropdownOpen, openActionMenuId, isMobileFilterOpen, isPaginationDropdownOpen]);
  useEffect(() => {
    const startAssignment = () => {
      setSelectedUsers([1]);
      document.querySelector('[data-phoebe-tour="learner-list"]')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    };
    window.addEventListener('phoebe:assign-learning', startAssignment);
    return () => window.removeEventListener('phoebe:assign-learning', startAssignment);
  }, []);
  // Mock data
  const quickStats = [{
    label: 'Total Learners',
    value: '248',
    change: '+12',
    trend: 'up',
    icon: Users
  }, {
    label: 'Active Admins',
    value: '8',
    change: '+2',
    trend: 'up',
    icon: Shield
  }, {
    label: 'Pending Invites',
    value: '18',
    change: '-5',
    trend: 'down',
    icon: Mail
  }, {
    label: 'Registered This Month',
    value: '32',
    change: '+8',
    trend: 'up',
    icon: TrendingUp
  }];
  const [learners, setLearners] = useState([{
    id: 1,
    name: 'Sarah Johnson',
    email: 'sarah.j@example.com',
    department: 'Marketing',
    cohort: 'Leadership Track',
    status: 'active',
    skills: 4,
    lastActive: '2024-01-15',
    joinDate: '2023-09-12',
    assignedSkills: ['Active and Empathetic Listening', 'Effective Communication', 'EQ for the Workplace', 'Developing EQ and Empathy'],
    assignedPathways: ['Leadership Essentials', 'Communication Mastery']
  }, {
    id: 2,
    name: 'Michael Chen',
    email: 'mchen@example.com',
    department: 'IT',
    cohort: 'Technical Upskilling',
    status: 'inactive',
    skills: 3,
    lastActive: '2023-12-01',
    joinDate: '2023-10-05',
    assignedSkills: ['AI Functionality Beyond the Hype', 'Effective Communication', 'EQ for the Workplace'],
    assignedPathways: ['Technical Foundations']
  }, {
    id: 3,
    name: 'Emily Davis',
    email: 'emily.d@example.com',
    department: 'Human Resources',
    cohort: '2024 Q1 Onboarding',
    status: 'pending',
    skills: 0,
    lastActive: 'Never',
    joinDate: '2024-01-10',
    assignedSkills: [],
    assignedPathways: []
  }, {
    id: 4,
    name: 'Rachel Green',
    email: 'rachel.g@example.com',
    department: 'Sales',
    cohort: 'Sales Enablement',
    status: 'not_assigned',
    skills: 0,
    lastActive: '2024-01-08',
    joinDate: '2023-07-20',
    assignedSkills: [],
    assignedPathways: []
  }, {
    id: 8,
    name: 'David Park',
    email: 'david.p@example.com',
    department: 'Operations',
    cohort: 'Leadership Track',
    status: 'not_started',
    skills: 2,
    lastActive: '2024-01-05',
    joinDate: '2023-12-15',
    assignedSkills: ['DEI: Employee Relations and Conflict Resolution', 'Developing EQ and Empathy'],
    assignedPathways: ['Leadership Essentials']
  }, {
    id: 9,
    name: 'Anna Martinez',
    email: 'anna.m@example.com',
    department: 'Finance',
    cohort: 'Leadership Track',
    status: 'completed',
    skills: 6,
    lastActive: '2024-01-14',
    joinDate: '2023-06-01',
    assignedSkills: ['AI Functionality Beyond the Hype', 'Active and Empathetic Listening', 'DEI: Employee Relations and Conflict Resolution', 'Developing EQ and Empathy', 'EQ for the Workplace', 'Effective Communication'],
    assignedPathways: ['Leadership Essentials', 'Technical Foundations', 'Communication Mastery']
  }, {
    id: 10,
    name: 'Brian Adams',
    email: 'brian.adams@example.com',
    department: 'Sales',
    cohort: 'Sales Enablement',
    status: 'active',
    skills: 2,
    lastActive: '2024-01-12',
    joinDate: '2023-11-08',
    assignedSkills: ['Effective Communication', 'Active and Empathetic Listening'],
    assignedPathways: []
  }, {
    id: 11,
    name: 'Priya Nair',
    email: 'priya.nair@example.com',
    department: 'IT',
    cohort: '2024 Q1 Onboarding',
    status: 'pending',
    skills: 0,
    lastActive: 'Never',
    joinDate: '2024-01-18',
    assignedSkills: [],
    assignedPathways: []
  }, {
    id: 12,
    name: 'Marcus Wilson',
    email: 'marcus.wilson@example.com',
    department: 'Operations',
    cohort: 'Technical Upskilling',
    status: 'not_started',
    skills: 3,
    lastActive: 'Never',
    joinDate: '2023-12-20',
    assignedSkills: ['Developing EQ and Empathy', 'EQ for the Workplace', 'Effective Communication'],
    assignedPathways: []
  }, {
    id: 13,
    name: 'Olivia Brooks',
    email: 'olivia.brooks@example.com',
    department: 'Marketing',
    cohort: '2024 Q1 Onboarding',
    status: 'inactive',
    skills: 1,
    lastActive: '2023-11-28',
    joinDate: '2023-08-14',
    assignedSkills: ['AI Functionality Beyond the Hype'],
    assignedPathways: []
  }]);
  const admins = [{
    id: 1,
    name: 'Linda Taylor',
    email: 'linda.taylor@example.com',
    status: 'active',
    role: 'Super Admin',
    lastActive: '2024-01-15',
    joinDate: '2023-01-10'
  }, {
    id: 2,
    name: 'Robert Martinez',
    email: 'robert.m@example.com',
    status: 'active',
    role: 'Admin',
    lastActive: '2024-01-14',
    joinDate: '2023-03-22'
  }, {
    id: 3,
    name: 'Jennifer Lee',
    email: 'jennifer.lee@example.com',
    status: 'active',
    role: 'Admin',
    lastActive: '2024-01-13',
    joinDate: '2023-05-18'
  }];
  const filteredUsers = (userType === 'learners' ? learners : admins).filter(user => {
    const userDepartment = 'department' in user ? user.department || '' : '';
    const userCohort = 'cohort' in user ? user.cohort || '' : '';
    const normalizedSearch = searchQuery.toLowerCase();
    const matchesSearch = user.name.toLowerCase().includes(normalizedSearch) || user.email.toLowerCase().includes(normalizedSearch) || userDepartment.toLowerCase().includes(normalizedSearch) || userCohort.toLowerCase().includes(normalizedSearch);
    const matchesFilter = selectedFilter === 'all' || (selectedFilter === 'not_assigned' ? 'assignedSkills' in user && Array.isArray((user as any).assignedSkills) && (user as any).assignedSkills.length === 0 : user.status === selectedFilter);
    const matchesDepartment = userType !== 'learners' || selectedDepartment === 'all' || userDepartment === selectedDepartment;
    const matchesCohort = userType !== 'learners' || selectedCohort === 'all' || userCohort === selectedCohort;
    return matchesSearch && matchesFilter && matchesDepartment && matchesCohort;
  }).sort((a, b) => {
    const valueA = sortField === 'department' && 'department' in a ? a.department || '' : a.name.trim().split(/\s+/).at(-1) || a.name;
    const valueB = sortField === 'department' && 'department' in b ? b.department || '' : b.name.trim().split(/\s+/).at(-1) || b.name;
    const comparison = valueA.localeCompare(valueB) || a.name.localeCompare(b.name);
    return sortDirection === 'asc' ? comparison : -comparison;
  });
  const toggleSort = (field: 'name' | 'department') => {
    if (sortField === field) {
      setSortDirection(direction => direction === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  // Only count selections that belong to the list currently on screen, so the
  // assignment bar never lingers after switching tabs or changing filters
  const activeSelectedUsers = selectedUsers.filter(userId => filteredUsers.some(user => user.id === userId));
  const selectedCount = activeSelectedUsers.length;
  const selectedLearnerLabel = `${selectedCount} ${selectedCount === 1 ? 'learner' : 'learners'}`;
  const totalPages = Math.max(1, Math.ceil(filteredUsers.length / itemsPerPage));
  const safeCurrentPage = Math.min(currentPage, totalPages);
  const paginatedUsers = filteredUsers.slice((safeCurrentPage - 1) * itemsPerPage, safeCurrentPage * itemsPerPage);
  const handleGenerateLink = () => {
    const linkType = userType === 'learners' ? 'learner' : 'admin';
    const newLink = `https://platform.example.com/register/${linkType}?token=${Math.random().toString(36).substr(2, 9)}`;
    setGeneratedLink(newLink);
  };
  const handleCopyLink = () => {
    navigator.clipboard.writeText(generatedLink);
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };
  const handleCreateDepartment = () => {
    const nextDepartment = newDepartmentName.trim();
    if (!nextDepartment) return;
    setDepartments(existing => existing.includes(nextDepartment) ? existing : [...existing, nextDepartment]);
    setDepartment(nextDepartment);
    setNewDepartmentName('');
    setIsCreatingDepartment(false);
    setIsDepartmentDropdownOpen(false);
  };
  const handleCreateCohort = () => {
    const nextCohort = newCohortName.trim();
    if (!nextCohort) return;
    setCohorts(existing => existing.includes(nextCohort) ? existing : [...existing, nextCohort]);
    setCohort(nextCohort);
    setNewCohortName('');
    setIsCreatingCohort(false);
    setIsCohortDropdownOpen(false);
  };
  const handleDownloadCsvTemplate = () => {
    const csv = 'First Name,Last Name,Email,Department\nTaylor,Smith,taylor.smith@example.com,Marketing\nJordan,Lee,jordan.lee@example.com,IT';
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'learner-import-template.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  const handleAddUser = () => {
    if (!firstName.trim() || !lastName.trim() || !email.trim() || !department) return;
    const newLearner = {
      id: Date.now(),
      name: `${firstName.trim()} ${lastName.trim()}`,
      email: email.trim(),
      department,
      cohort,
      status: 'pending',
      skills: selectedLicenses.length + selectedModalPathways.reduce((sum, pathway) => sum + (pathwayData.find(item => item.name === pathway)?.skillCount || 0), 0),
      lastActive: 'Never',
      joinDate: new Date().toISOString().split('T')[0],
      assignedSkills: selectedLicenses,
      assignedPathways: selectedModalPathways
    };
    setLearners(prev => [newLearner, ...prev]);
    setSelectedUsers([newLearner.id]);
    setToastMessage(`${newLearner.name} was added to ${department}.`);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 4000);
    setShowAddModal(false);
    setFirstName('');
    setLastName('');
    setEmail('');
    setDepartment('');
    setCohort('');
    setNewCohortName('');
    setRole('learner');
    setSelectedLicenses([]);
    setSelectedModalPathways([]);
    setLicenseSearch('');
    setAddModalStep('form');
    setAcknowledgeChecked(false);
  };
  const handleAddAdminEntry = () => {
    setAdminEntries([...adminEntries, {
      firstName: '',
      lastName: '',
      email: ''
    }]);
  };
  const handleAdminEntryChange = (index: number, field: string, value: string) => {
    const newEntries = [...adminEntries];
    newEntries[index] = {
      ...newEntries[index],
      [field]: value
    };
    setAdminEntries(newEntries);
  };
  const handleAdminSubmit = () => {
    const allFilled = adminEntries.every(entry => entry.firstName && entry.lastName && entry.email);
    if (allFilled && adminAcknowledge) {
      setAdminModalStep('confirm');
    }
  };
  const handleCloseAdminModal = () => {
    setShowAddAdminModal(false);
    setAdminModalStep('form');
    setAdminEntries([{
      firstName: '',
      lastName: '',
      email: ''
    }]);
    setAdminAcknowledge(false);
  };
  const toggleLicense = (skill: string) => {
    setSelectedLicenses(prev => prev.includes(skill) ? prev.filter(s => s !== skill) : [...prev, skill]);
  };
  const toggleModalPathway = (pathway: string) => {
    setSelectedModalPathways(prev => prev.includes(pathway) ? prev.filter(p => p !== pathway) : [...prev, pathway]);
  };
  const selectAllModalPathways = () => {
    const allPathwayNames = pathwayData.map(p => p.name);
    if (selectedModalPathways.length === allPathwayNames.length) {
      setSelectedModalPathways([]);
    } else {
      setSelectedModalPathways([...allPathwayNames]);
    }
  };
  const selectAllModalSkills = () => {
    if (selectedLicenses.length === availableSkills.length) {
      setSelectedLicenses([]);
    } else {
      setSelectedLicenses([...availableSkills]);
    }
  };
  const toggleLinkPathway = (pathway: string) => {
    setLinkPathways(prev => prev.includes(pathway) ? prev.filter(p => p !== pathway) : [...prev, pathway]);
  };
  const selectAllLinkPathways = () => {
    const allPathwayNames = pathwayData.map(p => p.name);
    if (linkPathways.length === allPathwayNames.length) {
      setLinkPathways([]);
    } else {
      setLinkPathways([...allPathwayNames]);
    }
  };
  const selectAllLinkSkills = () => {
    if (linkLicenses.length === availableSkills.length) {
      setLinkLicenses([]);
    } else {
      setLinkLicenses([...availableSkills]);
    }
  };
  const toggleLinkLicense = (skill: string) => {
    setLinkLicenses(prev => prev.includes(skill) ? prev.filter(s => s !== skill) : [...prev, skill]);
  };
  // Bulk Actions Handlers
  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (noLicensesAvailable) {
      e.preventDefault();
      setShowNoLicenseToast(true);
      setTimeout(() => setShowNoLicenseToast(false), 3000);
      return;
    }
    const pageUserIds = paginatedUsers.map(user => user.id);
    if (e.target.checked) {
      setSelectedUsers(previous => [...new Set([...previous, ...pageUserIds])]);
    } else {
      setSelectedUsers(previous => previous.filter(userId => !pageUserIds.includes(userId)));
    }
  };
  // The walkthrough selects a sample learner so the assignment bar is visible
  useEffect(() => {
    const handleDemoSelection = (event: Event) => {
      const shouldSelect = (event as CustomEvent<boolean>).detail;
      if (shouldSelect) {
        const firstLearner = filteredUsers[0];
        if (firstLearner) {
          setSelectedUsers([firstLearner.id]);
          setTourSelectedUserId(firstLearner.id);
        }
      } else {
        setSelectedUsers([]);
        setBulkSelectedSkills([]);
        setBulkSelectedPathways([]);
        setTourSelectedUserId(null);
      }
    };
    window.addEventListener('phoebe:demo-learner-selection', handleDemoSelection);
    return () => window.removeEventListener('phoebe:demo-learner-selection', handleDemoSelection);
  }, [filteredUsers]);
  const hasActiveFilters = Boolean(searchQuery) || selectedFilter !== 'all' || selectedDepartment !== 'all' || selectedCohort !== 'all';
  const resetFilters = () => {
    setSearchQuery('');
    setSelectedFilter('all');
    setSelectedDepartment('all');
    setSelectedCohort('all');
    setCurrentPage(1);
    setIsMobileFilterOpen(false);
    setIsDepartmentFilterDropdownOpen(false);
    setIsCohortFilterDropdownOpen(false);
  };
  const handleSelectAllFilteredUsers = () => {
    setSelectedUsers(filteredUsers.map(user => user.id));
  };
  const handleDeselectAllFilteredUsers = () => {
    const filteredUserIds = filteredUsers.map(user => user.id);
    setSelectedUsers(previous => previous.filter(userId => !filteredUserIds.includes(userId)));
  };
  const handleSelectUser = (id: number) => {
    if (noLicensesAvailable) {
      setShowNoLicenseToast(true);
      setTimeout(() => setShowNoLicenseToast(false), 3000);
      return;
    }
    setSelectedUsers(prev => prev.includes(id) ? prev.filter(userId => userId !== id) : [...prev, id]);
  };
  const toggleBulkSkill = (skill: string) => {
    if (skill === 'all') {
      if (bulkSelectedSkills.length === availableSkills.length) {
        setBulkSelectedSkills([]);
      } else {
        setBulkSelectedSkills([...availableSkills]);
      }
      return;
    }
    setBulkSelectedSkills(prev => prev.includes(skill) ? prev.filter(s => s !== skill) : [...prev, skill]);
  };
  const toggleBulkPathway = (pathway: string) => {
    if (pathway === 'all') {
      if (bulkSelectedPathways.length === availablePathways.length) {
        setBulkSelectedPathways([]);
      } else {
        setBulkSelectedPathways([...availablePathways]);
      }
      return;
    }
    setBulkSelectedPathways(prev => prev.includes(pathway) ? prev.filter(p => p !== pathway) : [...prev, pathway]);
  };
  const handleBulkAssign = () => {
    // Simulate assigning skills/pathways
    const totalAssigned = bulkSelectedSkills.length + bulkSelectedPathways.length;
    if (totalAssigned === 0) return;
    setLearners(prev => prev.map(learner => {
      if (selectedUsers.includes(learner.id)) {
        return {
          ...learner,
          skills: learner.skills + totalAssigned,
          status: learner.status === 'pending' ? 'inactive' : learner.status,
          assignedSkills: [...(learner.assignedSkills || []), ...bulkSelectedSkills],
          assignedPathways: [...(learner.assignedPathways || []), ...bulkSelectedPathways]
        };
      }
      return learner;
    }));
    setToastMessage(`Successfully assigned ${totalAssigned} items to ${selectedUsers.length} learners.`);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
    // Reset state
    setSelectedUsers([]);
    setBulkSelectedSkills([]);
    setBulkSelectedPathways([]);
    setIsBulkSkillDropdownOpen(false);
    setIsBulkPathwayDropdownOpen(false);
  };
  const handleSimulateBulkUpload = () => {
    // Transition to error review step with mock data
    setBulkUploadStep('errors');
    setBulkErrorEntries([{
      id: 'err1',
      row: 3,
      firstName: 'John',
      lastName: 'Doe',
      email: 'john.doe@example.com',
      department: 'Marketing',
      errors: {
        email: 'Duplicate email'
      },
      fixed: false
    }, {
      id: 'err2',
      row: 5,
      firstName: 'Jane',
      lastName: '',
      email: 'jane.smith@example.com',
      department: 'Sales',
      errors: {
        lastName: 'Last name is required'
      },
      fixed: false
    }]);
  };
  const handleBulkErrorChange = (id: string, field: string, value: string) => {
    setBulkErrorEntries(prev => prev.map(entry => {
      if (entry.id === id) {
        const newEntry = {
          ...entry,
          [field]: value
        };
        // Clear error for the field if it's being edited
        if (newEntry.errors && newEntry.errors[field]) {
          const newErrors = {
            ...newEntry.errors
          };
          delete newErrors[field];
          newEntry.errors = newErrors;
        }
        newEntry.fixed = false; // Reset fixed status if edited
        return newEntry;
      }
      return entry;
    }));
  };
  const handleFixAndAdd = (id: string) => {
    setBulkErrorEntries(prev => prev.map(entry => {
      if (entry.id === id) {
        // Simple validation simulation
        const newErrors: any = {};
        if (!entry.firstName) newErrors.firstName = 'First name is required';
        if (!entry.lastName) newErrors.lastName = 'Last name is required';
        if (!entry.email) newErrors.email = 'Email is required';else if (!/^\S+@\S+\.\S+$/.test(entry.email)) newErrors.email = 'Invalid email format';
        if (!entry.department) newErrors.department = 'Department is required';
        if (Object.keys(newErrors).length > 0) {
          return {
            ...entry,
            errors: newErrors,
            fixed: false
          };
        }
        return {
          ...entry,
          errors: {},
          fixed: true
        };
      }
      return entry;
    }));
  };
  const handleRemoveBulkError = (id: string) => {
    setBulkErrorEntries(prev => prev.filter(entry => entry.id !== id));
  };
  const handleSubmitBulkErrors = () => {
    const validEntries = bulkErrorEntries.filter(e => e.fixed || Object.keys(e.errors || {}).length === 0);
    if (validEntries.length > 0) {
      const newLearners = validEntries.map((entry, idx) => ({
        id: Date.now() + idx,
        name: `${entry.firstName} ${entry.lastName}`,
        email: entry.email,
        department: entry.department || '',
        status: 'pending',
        skills: 0,
        lastActive: 'Never',
        joinDate: new Date().toISOString().split('T')[0],
        assignedSkills: [],
        assignedPathways: []
      }));
      setLearners(prev => [...newLearners, ...prev]);
      setSelectedUsers(newLearners.map(l => l.id));
      setToastMessage(`Successfully imported ${newLearners.length} learners. Please assign them skills.`);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 4000);
    }
    setShowBulkModal(false);
    setBulkUploadStep('upload');
    setBulkErrorEntries([]);
  };
  const handleCloseBulkModal = () => {
    setShowBulkModal(false);
    setBulkUploadStep('upload');
    setBulkErrorEntries([]);
  };
  return <div className="flex-1 bg-gray-50 min-h-screen relative pb-24" data-id="element-2886" data-mp="oqevhj1fxn1w">
      {/* Success Toast */}
      <AnimatePresence data-id="element-2887" data-mp="w19t9cp7imkr">
        {showSuccessToast && <motion.div initial={{
        opacity: 0,
        y: -50
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -50
      }} className="fixed top-20 left-1/2 -translate-x-1/2 z-50 bg-[#007558] text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3" data-id="element-2888" data-mp="w2l39u98wqkb">
            <CheckCircle size={20} data-id="element-2889" data-mp="1a2dt7ncy72r8" />
            <span className="font-medium" data-id="element-2890" data-mp="1f0f95zf2ulyh">{toastMessage}</span>
          </motion.div>}
      </AnimatePresence>

      {/* No License Toast */}
      <AnimatePresence data-id="element-2891" data-mp="1jxxktxkhbfa6">
        {showNoLicenseToast && <motion.div initial={{
        opacity: 0,
        y: -50
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -50
      }} className="fixed top-20 left-1/2 -translate-x-1/2 z-50 bg-[#DB3725] text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3 max-w-md" data-id="element-2892" data-mp="1opytzamcopvz">
            <AlertCircle size={20} className="flex-shrink-0" data-id="element-2893" data-mp="22oyjslllnatq" />
            <span className="font-medium" data-id="element-2894" data-mp="22ndlqm02t9r4">
              No licenses remaining. Please purchase additional licenses to
              assign skills or pathways.
            </span>
          </motion.div>}
      </AnimatePresence>

      {/* Top Navigation */}
      <div className="bg-white border-b border-gray-200" data-id="element-2895" data-mp="ce20hm8q7sf8">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2896" data-mp="7mtqop3hi51j">
          <div className="flex items-center h-16" data-id="element-2897" data-mp="7kgy7i03oca8">
            {/* Logo */}
            <div className="text-[#DB3725] font-bold text-xl" data-id="element-2898" data-mp="m9wnetjzg9nt">LOGO</div>

            {/* Navigation Links */}
            <nav className="flex items-center gap-4 sm:gap-8 ml-6 sm:ml-12" data-id="element-2899" data-mp="hc3ie3uf1lp4">
              <Link data-phoebe-nav="/admin" to="/admin" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2900" data-mp="vautrihw8t9k">
                <Home size={18} data-id="element-2901" data-mp="2x39c2iocnzqi" />
                <span className="hidden sm:inline" data-id="element-2902" data-mp="2x4akefdze84j">Admin Hub</span>
              </Link>
              <Link data-phoebe-nav="/analytics" to="/analytics" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2903" data-mp="2s5hilk8245k7">
                <BarChart3 size={18} data-id="element-2904" data-mp="1cl73ucff34xd" />
                <span className="hidden sm:inline" data-id="element-2905" data-mp="1ck5inf4ot21x">Analytics</span>
              </Link>
              <Link data-phoebe-nav="/feedback" to="/feedback" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2906" data-mp="yt0q0wzqla13">
                <FileText size={18} data-id="element-2907" data-mp="ow5tgjn0xjpg" />
                <span className="hidden sm:inline" data-id="element-2908" data-mp="ov4brwbi5yyr">Reports</span>
              </Link>
              <Link data-phoebe-nav="/assessment" to="/assessment" className="flex items-center gap-2 text-[#30718D] border-b-2 border-[#30718D] pb-[22px] pt-[22px] transition-colors text-sm font-medium" data-id="element-2909" data-mp="tw0g2azrnn4p">
                <UserCog size={18} data-id="element-2910" data-mp="jxkpqa8kchw9" />
                <span className="hidden sm:inline" data-id="element-2911" data-mp="jyvvgflkjzq0">Users</span>
              </Link>
            </nav>

            {/* Right Side - User Info */}
            <div className="flex items-center gap-2 sm:gap-4 ml-auto" data-id="element-2912" data-mp="2eb3vu8gnt8t6">
              <Link data-phoebe-nav="/alerts" to="/alerts" aria-label="Notifications" className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-2913" data-mp="1pk66eo3ndmr4">
                <Bell size={20} data-id="element-2914" data-mp="1kluy4ht03kb0" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-[#DB3725] rounded-full" data-id="element-2915" data-mp="1fm0biqg9dgvr"></span>
              </Link>
              <div className="relative" ref={userMenuRef} data-id="element-2916" data-mp="1anf86i5pmh33">
                <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors" data-id="element-2917" data-mp="1ap052efhyc44">
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-2918" data-mp="11ttvd4d3v9wb">
                    LT
                  </div>
                  <span className="hidden sm:inline text-sm font-medium text-gray-900" data-id="element-2919" data-mp="rxh0w49qks0i">
                    Linda Taylor
                  </span>
                  <ChevronDown size={16} className="text-gray-600" data-id="element-2920" data-mp="mzfkjr3p36sq" />
                </button>

                {isUserMenuOpen && <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50" data-id="element-2921" data-mp="2uj36y7o0238d">
                    <div className="py-2" data-id="element-2922" data-mp="2yjwsiudyz5y3">
                      <Link to="/profile" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2923" data-mp="2ymre4p8pywt3">
                        <Users size={18} className="text-gray-600" data-id="element-2924" data-mp="38j45vhkpf0l7" />
                        <span className="font-medium text-gray-900" data-id="element-2925" data-mp="2av3v0thp8q1d">
                          Profile
                        </span>
                      </Link>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2926" data-mp="2fuq4qsybjo5f">
                        <Home size={18} className="text-gray-600" data-id="element-2927" data-mp="2pjzzkgkjrkx8" />
                        <span className="font-medium text-gray-900" data-id="element-2928" data-mp="2plb3cgdzssoc">
                          Learner Hub
                        </span>
                      </button>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2929" data-mp="1x2nnbfdus3u4">
                        <UserCog size={18} className="text-gray-600" data-id="element-2930" data-mp="1p0wqwy0s8jex" />
                        <span className="font-medium text-gray-900" data-id="element-2931" data-mp="1l0mjri197myh">
                          Admin Hub
                        </span>
                      </button>
                      <div className="border-t border-gray-200 my-2" data-id="element-2932" data-mp="1tt7t67izwhan"></div>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2933" data-mp="1645bx0s9wqgo">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-2934" data-mp="123lgq2r9fwx6">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-2935" data-mp="1b2yo8pvtqbf9"></path>
                          <polyline points="16 17 21 12 16 7" data-id="element-2936" data-mp="2rgynrzqrbz1z"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12" data-id="element-2937" data-mp="2rjb4k9ks43dg"></line>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-2938" data-mp="2mkrdxvv8q3er">
                          Logout
                        </span>
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8" data-id="element-2939" data-mp="48r6hc7q44vm">
        {/* Header with Toggle */}
        <div className="mb-8" data-id="element-2940" data-mp="ry3g2d6yqeyg">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4" data-id="element-2941" data-mp="rz51nbllujuf">
            <div data-id="element-2942" data-mp="vzoxmbufzhez">
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2" data-id="element-2943" data-mp="w2b4e99idsw5">
                User Management
              </h1>
              <p className="text-gray-600 text-sm sm:text-base" data-id="element-2944" data-mp="n7mzik7uid7v">
                Manage learners across your platform
              </p>
            </div>

            {/* Add Admin Button */}
            <div className="flex items-center self-start" data-id="element-2945" data-mp="1fo7hcdwoi2ma">
              <button data-phoebe-tour="add-admin" onClick={() => setShowAddAdminModal(true)} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors bg-white shadow-sm" data-id="element-2946" data-mp="1fpqwg16lm7mh">
                <Shield size={16} data-id="element-2947" data-mp="320rbc9fupkez" />
                Add Admin
              </button>
            </div>
          </div>
        </div>

        <section aria-labelledby="learner-workflow-title" className="mb-8 rounded-xl border border-[#30718D]/15 bg-[#EAF4F7] px-4 py-4 sm:px-6" data-id="element-2948" data-mp="2x40v9m41qotk">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between" data-id="element-2949" data-mp="3pr3p40xs2bdh">
            <div data-id="element-2950" data-mp="3ks0kghlpm761">
              <h2 id="learner-workflow-title" className="text-sm font-bold text-[#001823]" data-id="element-2951" data-mp="3krhc9slv2x57">A simple learner-management flow</h2>
              <p className="mt-1 text-sm text-[#365866]" data-id="element-2952" data-mp="3gpnhg0yckncy">Add learners, find them in the table, then review capacity before assigning skills or pathways.</p>
            </div>
            <ol className="flex flex-wrap items-center gap-2 text-xs font-semibold text-[#236B8C]" aria-label="Learner management steps" data-id="element-2953" data-mp="25aqmybje95y7">
              <li className="rounded-full bg-white px-3 py-1.5 shadow-sm" data-id="element-2954" data-mp="kusjsqk3jg6x">1. Add learners</li>
              <li aria-hidden="true" className="hidden text-[#5593B1] sm:block" data-id="element-2955" data-mp="ovchbv8l0ltl">→</li>
              <li className="rounded-full bg-white px-3 py-1.5 shadow-sm" data-id="element-2956" data-mp="tt498p9887xs">2. Review learners</li>
              <li aria-hidden="true" className="hidden text-[#5593B1] sm:block" data-id="element-2957" data-mp="ylnvsbpw6deq">→</li>
              <li className="rounded-full bg-white px-3 py-1.5 shadow-sm" data-id="element-2958" data-mp="13kiezerru3zd">3. Assign learning</li>
            </ol>
          </div>
        </section>

        {/* Quick Actions */}
        <div data-phoebe-tour="learners" className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-8" data-id="element-2959" data-mp="1cknbuuzc9jza">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-phoebe-tour="add-individual" onClick={() => setShowAddModal(true)} className="group bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all cursor-pointer" data-id="element-2960" data-mp="1hk0989nu69g4">
            <div className="flex items-center gap-4" data-id="element-2961" data-mp="3ufza2reua6r">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#30718D] to-[#265a70] flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2962" data-mp="3sv5wggu0xah">
                <UserPlus size={24} className="text-white" data-id="element-2963" data-mp="dsvuagtk63lj" />
              </div>
              <div className="flex-1" data-id="element-2964" data-mp="3cahsa8dycoyh">
                <h3 className="text-lg font-bold text-gray-900 mb-1 group-hover:text-[#30718D] transition-colors" data-id="element-2965" data-mp="3cbknutm7zfkq">
                  Add Individual Learner
                </h3>
                <p className="text-sm text-gray-600" data-id="element-2966" data-mp="3m85o71nao2i8">
                  Register a single learner
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} data-phoebe-tour="bulk-upload-learners" onClick={() => setShowBulkModal(true)} className="group bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all cursor-pointer" data-id="element-2967" data-mp="2tk03gew8qdie">
            <div className="flex items-center gap-4" data-id="element-2968" data-mp="16n1z3go4dc9c">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#007558] to-[#005a44] flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2969" data-mp="16lh5pudjjzd2">
                <Upload size={24} className="text-white" data-id="element-2970" data-mp="wp4h3awusbp6" />
              </div>
              <div className="flex-1" data-id="element-2971" data-mp="rye87np7xqpq">
                <h3 className="text-lg font-bold text-gray-900 mb-1 group-hover:text-[#007558] transition-colors" data-id="element-2972" data-mp="rxco6tq85tvv">
                  Bulk Upload Learners
                </h3>
                <p className="text-sm text-gray-600" data-id="element-2973" data-mp="iy92rj3l52e7">
                  Import multiple learners via CSV
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* User List */}
        <div data-phoebe-tour="learner-list" className="bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-2974" data-mp="90l8svdszyx3">
          <div className="p-4 sm:p-6 border-b border-gray-200" data-id="element-2975" data-mp="3vfqw4j9ew4t2">
            <div className="flex items-center justify-between mb-4" data-id="element-2976" data-mp="4b0v2s9hjf6z">
              <div className="flex items-center gap-2" data-id="element-2977" data-mp="3mgdo7v0xroag">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900" data-id="element-2978" data-mp="3mhygtf3owx5o">
                  All Learners ({filteredUsers.length})
                </h2>
                <AIInsightPopover headline="A focused follow-up could activate more learners" insightBeforeMetric="There are" highlightedMetric="4 learners" insightAfterMetric=" who are pending or have not started." explanation="A targeted reminder with a clear first step can help move these learners into active training." briefing={{
                metrics: [{
                  label: 'Learners needing follow-up',
                  value: '4'
                }, {
                  label: 'Pending registration',
                  value: '2'
                }, {
                  label: 'Not started',
                  value: '2'
                }],
                signals: ['Emily Davis and Priya Nair are pending account registration.', 'David Park and Marcus Wilson have not started their assigned learning.'],
                actions: ['Show the 4 learners', 'Draft a reminder for pending learners', 'Plan outreach for learners who have not started'],
                actionResponses: {
                  'Show the 4 learners': '**Learners needing follow-up**\n\n• Emily Davis — Pending registration\n• Priya Nair — Pending registration\n• David Park — Not started\n• Marcus Wilson — Not started\n\nStart with the two pending learners by resending their account-creation email, then send a focused learning reminder to David and Marcus.'
                }
              }} align="left" data-id="element-2979" data-mp="i1njnrlj7opc" />
              </div>
            </div>

            {/* Search and Filter */}
            <div className="flex flex-col items-stretch gap-3 xl:flex-row xl:items-center xl:gap-4" data-id="element-2980" data-mp="2hi0aa5h6ikdk">
              <div className="relative w-full xl:flex-1" data-id="element-2981" data-mp="2ci4egtimxz93">
                <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5E7079]" data-id="element-2982" data-mp="2ckqmsvdcoisd" />
                <input type="text" placeholder="Search name, email, or department" value={searchQuery} onChange={e => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }} className="w-full rounded-lg border border-gray-300 py-2.5 pl-11 pr-4 text-sm text-gray-900 placeholder:text-[#5E7079] focus:border-[#30718D] focus:outline-none focus:ring-2 focus:ring-[#30718D]/20" data-id="element-2983" data-mp="3sygsu7o15h4n" />
              </div>
              {userType === 'learners' && <div className="relative w-full sm:w-52 xl:flex-none" ref={departmentFilterDropdownRef} data-id="element-2984" data-mp="2bhrt7a0l5fs1">
                  <button type="button" onClick={() => setIsDepartmentFilterDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isDepartmentFilterDropdownOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-3 py-2 text-left text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isDepartmentFilterDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-2985" data-mp="2gf1fwhwlbdc6">
                    <span className="truncate" data-id="element-2986" data-mp="345nl81f7mjih">{selectedDepartment === 'all' ? 'All departments' : selectedDepartment || 'Unassigned'}</span>
                    <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isDepartmentFilterDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2987" data-mp="399pt1cr38qo9" />
                  </button>
                  {isDepartmentFilterDropdownOpen && <div role="listbox" aria-label="Filter learners by department" className="absolute z-30 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-2988" data-mp="30a2zfd4lop5r">
                      {[{
                  value: 'all',
                  label: 'All departments'
                }, ...departments.map(item => ({
                  value: item,
                  label: item
                })), {
                  value: '',
                  label: 'Unassigned'
                }].map((option, index, options) => <button key={option.value || 'unassigned'} type="button" role="option" aria-selected={selectedDepartment === option.value} onClick={() => {
                  setSelectedDepartment(option.value);
                  setCurrentPage(1);
                  setIsDepartmentFilterDropdownOpen(false);
                }} className={`flex w-full items-center px-3 py-2.5 text-left text-sm transition-colors ${index < options.length - 1 ? 'border-b border-gray-100' : ''} ${selectedDepartment === option.value ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2989" data-mp="3j85ilbagvrvn" data-mpi={index}>
                        {option.label}
                      </button>)}
                    </div>}
                </div>}
              {userType === 'learners' && <div className="relative w-full sm:w-52 xl:flex-none" ref={cohortFilterDropdownRef} data-id="element-2990" data-mp="1q9guuxvg0v9x">
                  <button type="button" onClick={() => setIsCohortFilterDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isCohortFilterDropdownOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-3 py-2 text-left text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isCohortFilterDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-2991" data-mp="1vbfx24fg5m5a">
                    <span className="truncate" data-id="element-2992" data-mp="143o366wvqy7v">{selectedCohort === 'all' ? 'All cohorts' : selectedCohort || 'No cohort'}</span>
                    <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isCohortFilterDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2993" data-mp="z5cva1q5axsa" />
                  </button>
                  {isCohortFilterDropdownOpen && <div role="listbox" aria-label="Filter learners by cohort" className="absolute z-30 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-2994" data-mp="1msueh8vcgnjn">
                      {[{
                  value: 'all',
                  label: 'All cohorts'
                }, ...cohorts.map(item => ({
                  value: item,
                  label: item
                })), {
                  value: '',
                  label: 'No cohort'
                }].map((option, index, options) => <button key={option.value || 'no-cohort'} type="button" role="option" aria-selected={selectedCohort === option.value} onClick={() => {
                  setSelectedCohort(option.value);
                  setCurrentPage(1);
                  setIsCohortFilterDropdownOpen(false);
                }} className={`flex w-full items-center px-3 py-2.5 text-left text-sm transition-colors ${index < options.length - 1 ? 'border-b border-gray-100' : ''} ${selectedCohort === option.value ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2995" data-mp="1rsqj9abv8j09" data-mpi={index}>
                        {option.label}
                      </button>)}
                    </div>}
                </div>}
              {/* Status filter */}
              <div className="relative w-full sm:w-52 xl:flex-none" ref={mobileFilterRef} data-id="element-2996" data-mp="2tqn3xwbzy9zk">
                <button type="button" onClick={() => setIsMobileFilterOpen(!isMobileFilterOpen)} aria-haspopup="listbox" aria-expanded={isMobileFilterOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-3 py-2 text-left text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isMobileFilterOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-2997" data-mp="2ypq0sthtp9wg">
                  <span className="flex min-w-0 items-center gap-2" data-id="element-2998" data-mp="23fbf2v2l511u">
                    <Filter size={16} aria-hidden="true" className="flex-shrink-0 text-gray-400" data-id="element-2999" data-mp="1yh05mlg7csk5" />
                    <span className="truncate" data-id="element-3000" data-mp="1tq9vkuwu01j4">{STATUS_FILTERS.find(option => option.value === selectedFilter)?.label || 'All statuses'}</span>
                  </span>
                  <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isMobileFilterOpen ? 'rotate-180' : ''}`} data-id="element-3001" data-mp="1opvyu90oke0e" />
                </button>
                {isMobileFilterOpen && <div role="listbox" aria-label="Filter learners by status" className="absolute z-30 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-3002" data-mp="1arp95g5vxkbt">
                    {STATUS_FILTERS.map((option, index, options) => <button key={option.value} type="button" role="option" aria-selected={selectedFilter === option.value} onClick={() => {
                  setSelectedFilter(option.value);
                  setCurrentPage(1);
                  setIsMobileFilterOpen(false);
                }} className={`flex w-full items-center px-3 py-2.5 text-left text-sm transition-colors ${index < options.length - 1 ? 'border-b border-gray-100' : ''} ${selectedFilter === option.value ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-3003" data-mp="354ni9wfumaxk" data-mpi={index}>
                        {option.label}
                      </button>)}
                  </div>}
              </div>
              <button type="button" onClick={resetFilters} disabled={!hasActiveFilters} className="flex w-full items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-[#30718D] transition-colors hover:bg-[#30718D]/10 focus:outline-none focus:ring-2 focus:ring-[#30718D] disabled:cursor-not-allowed disabled:text-gray-400 disabled:hover:bg-transparent sm:w-auto xl:ml-auto" data-id="element-3004" data-mp="32jdl6qryak8a">
                <RotateCcw size={15} aria-hidden="true" data-id="element-3005" data-mp="rrkdkuh2d98f" />
                Reset filters
              </button>
            </div>
            {paginatedUsers.length > 0 && paginatedUsers.every(user => selectedUsers.includes(user.id)) && <div className="mt-4 flex flex-col gap-2 rounded-lg border border-[#30718D]/20 bg-[#30718D]/5 px-4 py-3 text-sm sm:flex-row sm:items-center sm:justify-between" data-id="element-3006" data-mp="14a6a79kcsh0l">
                {selectedUsers.length === filteredUsers.length ? <>
                    <p className="font-medium text-[#236B8C]" data-id="element-3007" data-mp="1i0t7cxagtyuk">All {filteredUsers.length} learners in this table are selected.</p>
                    <button type="button" onClick={handleDeselectAllFilteredUsers} className="w-fit font-semibold text-[#30718D] underline decoration-1 underline-offset-4 hover:text-[#265A70] focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:ring-offset-2" data-id="element-3008" data-mp="1n05t1eplozvk">Deselect all</button>
                  </> : <>
                    <p className="text-gray-700" data-id="element-3009" data-mp="20ym9vyh6g6rf">All {paginatedUsers.length} learners on this page are selected.</p>
                    <button type="button" onClick={handleSelectAllFilteredUsers} className="w-fit font-semibold text-[#30718D] underline decoration-1 underline-offset-4 hover:text-[#265A70] focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:ring-offset-2" data-id="element-3010" data-mp="25ryln80rcj2r">Select all {filteredUsers.length} learners</button>
                  </>}
              </div>}
          </div>

          {/* Users Table */}
          <div className="overflow-x-auto" data-id="element-3011" data-mp="21m36oxg24tov">
            <table className="w-full sm:min-w-[1080px]" data-id="element-3012" data-mp="1wni8f3kd8k32">
              <thead data-id="element-3013" data-mp="1wp33qvei871z">
                <tr className="border-b border-gray-200 bg-gray-50" data-id="element-3014" data-mp="1wpcsygrq6a6m">
                  <th data-phoebe-tour="select-all" className="py-3 pl-3 pr-1 sm:px-6 w-8 sm:w-12" data-id="element-3015" data-mp="1rv8l7vamxy4h">
                    <input type="checkbox" aria-label="Select all learners on this page" checked={paginatedUsers.length > 0 && paginatedUsers.every(user => selectedUsers.includes(user.id))} onChange={handleSelectAll} className={`w-4 h-4 rounded border-gray-300 transition-colors ${noLicensesAvailable ? 'opacity-40 cursor-pointer accent-gray-400' : 'text-[#30718D] focus:ring-[#30718D] cursor-pointer'}`} data-id="element-3016" data-mp="1my8bnaekud8m" />
                  </th>
                  <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700" data-id="element-3017" data-mp="3knn91d927yuu">
                    <button onClick={() => toggleSort('name')} aria-label={`Sort learners by last name ${sortField === 'name' && sortDirection === 'asc' ? 'descending' : 'ascending'}`} className="flex items-center gap-1.5 text-[#374151] hover:text-gray-900 transition-colors" data-id="element-3018" data-mp="3pm6z9puorwt0">
                      <span data-id="element-3019" data-mp="31wmcevvewfeg">Name</span>
                      {sortField === 'name' && (sortDirection === 'asc' ? <ArrowDownAZ size={18} aria-hidden="true" strokeWidth={2} data-id="element-3020" data-mp="36ue2dkchxrg0" /> : <ArrowUpAZ size={18} aria-hidden="true" strokeWidth={2} data-id="element-3021" data-mp="3av7t0lhbpkcl" />)}
                    </button>
                  </th>
                  {userType === 'learners' && <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700 hidden md:table-cell" data-id="element-3022" data-mp="3fo0y5agpeup7">
                    <button onClick={() => toggleSort('department')} className="flex items-center gap-1 hover:text-gray-900 transition-colors" data-id="element-3023" data-mp="2n5n8hy5iuf17">
                      Department
                      {sortField === 'department' && <span className="text-xs text-gray-400" data-id="element-3024" data-mp="1z2padmkwodmv">
                        {sortDirection === 'asc' ? '↑' : '↓'}
                      </span>}
                    </button>
                  </th>}
                  {userType === 'learners' && <th className="hidden lg:table-cell text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700" data-id="element-3025" data-mp="28zlcnak7o3iz">
                    Cohort
                  </th>}
                  <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700" data-id="element-3026" data-mp="2htgfud1rvjvz">
                    Status
                  </th>
                  <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700 hidden sm:table-cell" data-id="element-3027" data-mp="2wnv2qoogjdfx">
                    Skill Modules
                  </th>
                  <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700 hidden sm:table-cell" data-id="element-3028" data-mp="12cpu15yikatq">
                    Last Active
                  </th>
                  <th className="w-16 py-3 px-2 text-center font-semibold text-sm text-gray-700 sm:w-24 sm:px-6" data-id="element-3029" data-mp="38zx6cbut322t">
                    Details
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-3030" data-mp="2z9c9otyp07mj">
                <AnimatePresence mode="wait" data-id="element-3031" data-mp="2z9udcbnopo4h">
                  {paginatedUsers.map((user, index) => <Fragment key={`${userType}-${user.id}`} data-id="element-3032" data-mp="3485ocpppu4oa" data-mpi={index}>
                      <motion.tr initial={{
                    opacity: 0,
                    y: 10
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} exit={{
                    opacity: 0,
                    y: -10
                  }} transition={{
                    delay: index * 0.05
                  }} onClick={e => {
                    const target = e.target as HTMLElement;
                    if (!target.closest('input[type="checkbox"]') && !target.closest('button')) {
                      setExpandedUserId(expandedUserId === user.id ? null : user.id);
                    }
                  }} className={`border-b border-gray-100 transition-colors cursor-pointer ${expandedUserId === user.id ? 'bg-gray-50' : 'hover:bg-gray-50'}`} data-id="element-3033" data-mp="2q9xifsapbt0z">
                        <td className="py-3 sm:py-4 pl-3 pr-1 sm:px-6" data-id="element-3034" data-mp="83379x4dl82h">
                          <input type="checkbox" checked={selectedUsers.includes(user.id)} onChange={() => handleSelectUser(user.id)} className={`w-4 h-4 rounded border-gray-300 transition-colors ${tourSelectedUserId === user.id ? 'phoebe-nav-active' : ''} ${noLicensesAvailable ? 'opacity-40 cursor-pointer accent-gray-400' : 'text-[#30718D] focus:ring-[#30718D] cursor-pointer'}`} data-id="element-3035" data-mp="34tcvoqh6bhx" />
                        </td>
                        <td className="py-3 sm:py-4 px-3 sm:px-6" data-id="element-3036" data-mp="m4796dbofybl">
                          <div className="flex items-center gap-2 sm:gap-3" data-id="element-3037" data-mp="m1tfo8wnau65">
                            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#30718D] flex items-center justify-center text-white text-xs sm:text-sm font-bold flex-shrink-0" data-id="element-3038" data-mp="1jkmiocs40hc4">
                              {user.name.split(' ').map(n => n[0]).join('')}
                            </div>
                            <div className="min-w-0" data-id="element-3039" data-mp="1r32pziclqepd">
                              <div className="truncate text-sm font-medium text-gray-900" data-id="element-3040" data-mp="1w149u5huqi1w">
                                {user.name}
                              </div>
                              <div className="truncate text-xs text-gray-700 sm:text-sm" data-id="element-3041" data-mp="20ydw5c9y2dli">
                                {user.email}
                              </div>
                              {/* Mobile-only summary of the hidden columns */}
                              <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-gray-500 sm:hidden" data-id="element-3042" data-mp="2et6juxzzn036">
                                <span data-id="element-3043" data-mp="2jqgjt7l06u59">{`${user.skills} skills`}</span>
                                <span aria-hidden="true" data-id="element-3044" data-mp="2ormakzv3s7c5">·</span>
                                <span className="truncate" data-id="element-3045" data-mp="2tp5xsp9s3ug8">{user.lastActive}</span>
                                {userType === 'learners' && 'department' in user && user.department && <>
                                    <span aria-hidden="true" data-id="element-3046" data-mp="3a1jicrko0ba5">·</span>
                                    <span className="truncate" data-id="element-3047" data-mp="3a3dsdaueeizg">{user.department}</span>
                                  </>}
                              </div>
                            </div>
                          </div>
                        </td>
                        {userType === 'learners' && <td className="hidden md:table-cell py-3 sm:py-4 px-3 sm:px-6 text-sm text-gray-600" data-id="element-3048" data-mp="2vd6gjdywby7q">
                            {'department' in user && user.department ? <span className="inline-flex max-w-[12rem] truncate rounded bg-[#30718D]/10 px-2 py-1 text-xs font-medium text-[#30718D]" title={user.department} data-id="element-3049" data-mp="351wulo77ncn3">{user.department}</span> : <span className="text-gray-400" data-id="element-3050" data-mp="309dikvo68pke">—</span>}
                          </td>}
                        {userType === 'learners' && <td className="hidden lg:table-cell py-3 sm:py-4 px-3 sm:px-6 text-sm text-gray-600" data-id="element-3051" data-mp="27n2ehb1cw6iu">
                            {'cohort' in user && user.cohort ? <span className="inline-flex max-w-[12rem] truncate rounded bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700" title={user.cohort} data-id="element-3052" data-mp="n374o3wo3hok">{user.cohort}</span> : <span className="text-gray-400" data-id="element-3053" data-mp="e4lmi9v3y4ob">—</span>}
                          </td>}
                        <td className="py-3 sm:py-4 px-3 sm:px-6" data-id="element-3054" data-mp="j2n7j0c3ge2f">
                          <div className="relative group/status inline-flex" data-id="element-3055" data-mp="j0sj3c1m63tl">
                            <span className={`inline-flex h-6 items-center justify-center rounded border bg-white px-3 text-xs font-bold whitespace-nowrap cursor-help ${user.status === 'active' ? 'border-[#5290A6] text-[#30718D]' : user.status === 'completed' ? 'border-[#05634B] text-[#05634B]' : user.status === 'pending' ? 'border-[#BFAF00] text-[#A16207]' : user.status === 'not_started' ? 'border-[#7E22CE] text-[#7E22CE]' : user.status === 'not_assigned' ? 'border-[#DB3725] text-[#DB3725]' : user.status === 'inactive' ? 'border-[#828282] text-[#6B7280]' : 'border-gray-300 text-gray-600'}`} data-id="element-3056" data-mp="16tisbdi4u906">
                              {user.status === 'not_assigned' ? 'Not Assigned' : user.status === 'not_started' ? 'Not Started' : user.status.charAt(0).toUpperCase() + user.status.slice(1)}
                            </span>
                            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden w-56 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg shadow-lg text-center opacity-0 invisible group-hover/status:opacity-100 group-hover/status:visible transition-all duration-150 z-50 pointer-events-none sm:block" data-id="element-3057" data-mp="3ru6b0lxzznvz">
                              {user.status === 'not_assigned' && 'This learner has no skill modules or Pathways assigned to them.'}
                              {user.status === 'pending' && 'This learner has not completed their account registration. Send them a reminder email.'}
                              {user.status === 'not_started' && 'This learner has not started any skill modules or Pathways. Send them a reminder email.'}
                              {user.status === 'active' && 'This learner has accessed a skill module in the past 30 days.'}
                              {user.status === 'inactive' && 'This learner has not accessed a skill module in the past 30 days. Send them a reminder email.'}
                              {user.status === 'completed' && 'This learner completed all available skill modules and Pathways.'}
                              <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-px border-4 border-transparent border-t-gray-900" data-id="element-3058" data-mp="2ze89j4i4nrh3" />
                            </div>
                          </div>
                        </td>
                        <td className="py-3 sm:py-4 px-3 sm:px-6 text-sm text-gray-600 hidden sm:table-cell" data-id="element-3059" data-mp="3471dvr9ooxsn">
                          {`${user.skills} skills`}
                        </td>
                        <td className="py-3 sm:py-4 px-3 sm:px-6 text-sm text-gray-600 hidden sm:table-cell" data-id="element-3060" data-mp="3d7hfswas3wve">
                          {user.lastActive}
                        </td>
                        <td className="py-3 sm:py-4 px-1 sm:px-6" data-id="element-3061" data-mp="2as8ecjofre9l">
                          <div className="flex items-center justify-center" data-id="element-3062" data-mp="2ftxozy7qxpx5">
                            <button type="button" onClick={() => setExpandedUserId(expandedUserId === user.id ? null : user.id)} aria-expanded={expandedUserId === user.id} aria-label={`${expandedUserId === user.id ? 'Hide' : 'Show'} details for ${user.name}`} className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#30718D]" data-id="element-3063" data-mp="2juhr7g76fjq5">
                              <ChevronDown size={18} aria-hidden="true" className={`transition-transform ${expandedUserId === user.id ? 'rotate-180' : ''}`} data-id="element-3064" data-mp="33k1ukb4hvzqs" />
                            </button>
                          </div>
                        </td>
                      </motion.tr>

                      {/* Expanded Row Details */}
                      <AnimatePresence data-id="element-3065" data-mp="1d84b2pyqj1h9">
                        {expandedUserId === user.id && <motion.tr initial={{
                      opacity: 0
                    }} animate={{
                      opacity: 1
                    }} exit={{
                      opacity: 0
                    }} transition={{
                      duration: 0.2
                    }} data-id="element-3066" data-mp="15ocu53y4924z">
                            <td colSpan={userType === 'learners' ? 8 : 6} className="bg-gray-50 px-4 sm:px-6 py-4 border-b border-gray-200" data-id="element-3067" data-mp="rx81wmx2vc4o">
                              <motion.div initial={{
                          height: 0,
                          opacity: 0
                        }} animate={{
                          height: 'auto',
                          opacity: 1
                        }} exit={{
                          height: 0,
                          opacity: 0
                        }} transition={{
                          duration: 0.3
                        }} className="overflow-hidden" data-id="element-3068" data-mp="1jmt4d4v6tarv">
                                <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-3069" data-mp="1n3nuz63b8tjb">
                                  {/* Assigned Pathways */}
                                  <div className="pb-4 border-b border-gray-200" data-id="element-3070" data-mp="1rvp5onktyc78">
                                    <p className="text-xs font-medium text-gray-500 mb-3" data-id="element-3071" data-mp="1e40qucj759mk">
                                      Assigned Pathways{' '}
                                      <span className="uppercase" data-id="element-3072" data-mp="25tvrh5ci8lqj">
                                        (
                                        {user.assignedPathways && user.assignedPathways.length > 0 ? `${user.assignedPathways.reduce((sum: number, name: string) => sum + (pathwayData.find(p => p.name === name)?.skillCount || 0), 0)} SKILLS` : '0 SKILLS'}
                                        )
                                      </span>
                                    </p>
                                    {user.assignedPathways && user.assignedPathways.length > 0 ? <div className="flex flex-wrap gap-2" data-id="element-3073" data-mp="qdwsajkv802f">
                                        {user.assignedPathways.map((pathway, idx) => <span key={idx} className="inline-flex items-center gap-2 px-2.5 py-1.5 bg-purple-50 rounded text-xs font-medium text-purple-700" data-id="element-3074" data-mp="hy7hs56br6iy" data-mpi={idx}>
                                              <span className="text-[10px] font-bold uppercase tracking-wide" data-id="element-3075" data-mp="rtscrjcz76j7">
                                                Pathway
                                              </span>
                                              {pathway}
                                            </span>)}
                                      </div> : <p className="text-sm text-gray-400 italic" data-id="element-3076" data-mp="3qa3avm71p4ab">
                                        No pathways assigned
                                      </p>}
                                  </div>

                                  {/* Assigned Skills */}
                                  <div className="pt-4" data-id="element-3077" data-mp="3ciouln4ivh6y">
                                    <p className="text-xs font-medium text-gray-500 mb-3" data-id="element-3078" data-mp="37m82yiy46kp4">
                                      Assigned Skills{' '}
                                      <span className="uppercase" data-id="element-3079" data-mp="1bg7fxlmmprtt">
                                        (
                                        {user.assignedSkills ? user.assignedSkills.length : 0}{' '}
                                        SKILLS)
                                      </span>
                                    </p>
                                    {user.assignedSkills && user.assignedSkills.length > 0 ? <div className="flex flex-wrap gap-2" data-id="element-3080" data-mp="sliqy8f9vs0a">
                                        {user.assignedSkills.map((skill, idx) => <span key={idx} className="px-2.5 py-1.5 bg-[#30718D]/10 rounded text-xs font-medium text-[#30718D]" data-id="element-3081" data-mp="11k441o1z6eto" data-mpi={idx}>
                                              {skill}
                                            </span>)}
                                      </div> : <p className="text-sm text-gray-400 italic" data-id="element-3082" data-mp="2cyree6ikejan">
                                        No skills assigned
                                      </p>}
                                  </div>
                                </div>
                              </motion.div>
                            </td>
                          </motion.tr>}
                      </AnimatePresence>
                    </Fragment>)}
                </AnimatePresence>
              </tbody>
            </table>

            {/* Pagination */}
            {filteredUsers.length > 0 && totalPages > 1 && <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6" data-id="element-3083" data-mp="29cm6oxvnb2a8">
                <p className="text-sm text-gray-600" data-id="element-3084" data-mp="24f2s1wv1cnhr">
                  Showing {(safeCurrentPage - 1) * itemsPerPage + 1}–
                  {Math.min(safeCurrentPage * itemsPerPage, filteredUsers.length)}{' '}
                  of {filteredUsers.length}
                </p>
                <div className="flex items-center gap-2" data-id="element-3085" data-mp="3tqv7od3ilmsx">
                  <span className="text-sm text-gray-600" data-id="element-3086" data-mp="3ppt8fw9llaqy">Page</span>
                  <div className="relative" ref={paginationDropdownRef} data-id="element-3087" data-mp="ctezihtcs655">
                    <button type="button" onClick={() => setIsPaginationDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isPaginationDropdownOpen} aria-label="Select page" className={`flex min-w-14 items-center justify-between rounded-md border bg-white py-1 pl-2 pr-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D]/20 ${isPaginationDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 text-[#30718D]' : 'border-gray-300 text-gray-700'}`} data-id="element-3088" data-mp="cvjepvwpcrkq">
                      <span data-id="element-3089" data-mp="3u7k4ot4zq5c0">{safeCurrentPage}</span>
                      <ChevronDown size={14} aria-hidden="true" className={`ml-2 text-gray-400 transition-transform ${isPaginationDropdownOpen ? 'rotate-180' : ''}`} data-id="element-3090" data-mp="3gb70glpgw0fh" />
                    </button>
                    {isPaginationDropdownOpen && <div role="listbox" aria-label="Select page" className="absolute bottom-full z-30 mb-1 max-h-60 min-w-full overflow-y-auto overflow-x-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-3091" data-mp="1ejbu8llzco4n">
                        {Array.from({
                    length: totalPages
                  }, (_, i) => i + 1).map(page => <button key={page} type="button" role="option" aria-selected={safeCurrentPage === page} onClick={() => {
                    setCurrentPage(page);
                    setIsPaginationDropdownOpen(false);
                  }} className={`flex w-full items-center border-b border-gray-100 px-3 py-2 text-left text-sm transition-colors last:border-b-0 ${safeCurrentPage === page ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-3092" data-mp="1okw7vegkwue7">
                          {page}
                        </button>)}
                      </div>}
                  </div>
                  <span className="text-sm text-gray-600" data-id="element-3093" data-mp="qyyvzzwpfnb8">of {totalPages}</span>
                </div>
              </div>}
          </div>

          {filteredUsers.length === 0 && <div className="p-12 text-center" data-id="element-3094" data-mp="mz6jjc46wx0l">
              <Users size={48} className="mx-auto text-gray-400 mb-4" data-id="element-3095" data-mp="3s1hpkrs9807w" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-3096" data-mp="3s2srsn61wzww">
                No users found
              </h3>
              <p className="text-gray-600" data-id="element-3097" data-mp="3iavhrjqs4dzr">
                Try adjusting your search or filter criteria
              </p>
            </div>}
        </div>

        <SkillsOverview data-id="element-3098" data-mp="3dbs9lqfi5rnk" />
      </div>

      {/* Add Admin Modal */}
      <AnimatePresence data-id="element-3099" data-mp="39bi56i7cz9at">
        {showAddAdminModal && <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={handleCloseAdminModal} data-id="element-3100" data-mp="398dwb7iy7pdt">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="bg-white rounded-xl p-6 max-w-lg w-full shadow-2xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-3101" data-mp="2zbrc8kyg52cu">
              <div className="flex items-center justify-between mb-6" data-id="element-3102" data-mp="112lfx3vf691r">
                <div className="flex items-center gap-3" data-id="element-3103" data-mp="153dqc0g12jzm">
                  <div className="w-10 h-10 rounded-full bg-[#30718D]/10 flex items-center justify-center" data-id="element-3104" data-mp="19v5fc6jjchnn">
                    <Shield size={20} className="text-[#30718D]" data-id="element-3105" data-mp="1etyvy7u4cos1" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-3106" data-mp="i3zflr7q8lyw">
                    {adminModalStep === 'form' ? 'Add Admin' : 'Admin Added'}
                  </h2>
                </div>
                <button onClick={handleCloseAdminModal} className="text-sm font-semibold text-gray-700 hover:text-gray-900 underline transition-colors" data-id="element-3107" data-mp="m7e2n1u322lu">
                  Close
                </button>
              </div>

              {adminModalStep === 'form' ? <>
                  <p className="text-sm text-gray-600 mb-6" data-id="element-3108" data-mp="22jktyryr8xyg">
                    Provide the following information to add an additional
                    administrator account.
                  </p>

                  <div className="space-y-6 mb-6" data-id="element-3109" data-mp="1hsxfkyoe6si4">
                    {adminEntries.map((entry, index) => <div key={index} className="space-y-4" data-id="element-3110" data-mp="1cv5mw2fxb2cv" data-mpi={index}>
                        <h3 className="text-sm font-bold text-gray-900" data-id="element-3111" data-mp="1rthj67zdw93i">
                          Admin {index + 1}
                        </h3>
                        <div className="grid grid-cols-2 gap-4" data-id="element-3112" data-mp="1mumpuc3sj255">
                          <div data-id="element-3113" data-mp="z5byfl8byk3o">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3114" data-mp="z4k0w4v6acar">
                              First Name{' '}
                              <span className="text-[#DB3725]" data-id="element-3115" data-mp="18ttwhup86d3m">*</span>
                            </label>
                            <input type="text" placeholder="Enter first name" value={entry.firstName} onChange={e => handleAdminEntryChange(index, 'firstName', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-3116" data-mp="142tz6oc71t0l" />
                          </div>
                          <div data-id="element-3117" data-mp="2n0qkh4gxu48q">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3118" data-mp="2rsru0imq1gv2">
                              Last Name{' '}
                              <span className="text-[#DB3725]" data-id="element-3119" data-mp="2d4x1b28prchz">*</span>
                            </label>
                            <input type="text" placeholder="Enter last name" value={entry.lastName} onChange={e => handleAdminEntryChange(index, 'lastName', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-3120" data-mp="2i3qdmrc9kxgk" />
                          </div>
                        </div>
                        <div data-id="element-3121" data-mp="30sok8oorens8">
                          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3122" data-mp="30rvbxja5jq7z">
                            Email <span className="text-[#DB3725]" data-id="element-3123" data-mp="1lb4o66nc2733">*</span>
                          </label>
                          <input type="email" placeholder="Enter email address" value={entry.email} onChange={e => handleAdminEntryChange(index, 'email', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-3124" data-mp="1pfufrjaykzi7" />
                        </div>
                      </div>)}
                  </div>

                  <div className="mb-6" data-id="element-3125" data-mp="1qy4993rasyvv">
                    <label className="flex items-start gap-3 cursor-pointer" data-id="element-3126" data-mp="2ok9x87zh178z">
                      <input type="checkbox" checked={adminAcknowledge} onChange={e => setAdminAcknowledge(e.target.checked)} className="w-4 h-4 mt-0.5 rounded border-gray-300 text-[#30718D] focus:ring-[#30718D]" data-id="element-3127" data-mp="2oi79julsjq7f" />
                      <span className="text-sm text-gray-700 leading-snug" data-id="element-3128" data-mp="2akireuj3yx62">
                        <span className="text-[#DB3725]" data-id="element-3129" data-mp="2amleb5oysa6k">*</span> I acknowledge
                        that I have the authority to share the information of
                        the learners I provided.
                      </span>
                    </label>
                  </div>

                  <div className="flex gap-3 mb-6" data-id="element-3130" data-mp="3aua1xj8s2n5w">
                    <button onClick={handleAddAdminEntry} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-3131" data-mp="3etslobov4s75">
                      Add another
                    </button>
                    <button onClick={handleAdminSubmit} disabled={!adminAcknowledge || !adminEntries.every(e => e.firstName && e.lastName && e.email)} className={`flex-1 px-4 py-2 rounded-lg transition-colors font-medium shadow-sm ${adminAcknowledge && adminEntries.every(e => e.firstName && e.lastName && e.email) ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-3132" data-mp="3olojdln1egau">
                      Submit
                    </button>
                  </div>

                  <div className="space-y-3 border-t border-gray-200 pt-4" data-id="element-3133" data-mp="287exqza6j5np">
                    <p className="text-gray-500 text-xs leading-relaxed" data-id="element-3134" data-mp="2d5zxkxlirnbm">
                      New admins will have all the same capabilities you
                      currently have, including registering employees for
                      training, monitoring learning progress, adding additional
                      administrator accounts and purchasing¹ more training to be
                      distributed through this License Management interface.
                    </p>
                    <p className="text-gray-400 text-xs" data-id="element-3135" data-mp="38sqh9ipahv4">
                      ¹ Payment information is never saved or stored and all
                      admins will have to enter new payment information when
                      purchasing additional training content.
                    </p>
                  </div>
                </> : <div className="py-8 text-center flex flex-col items-center" data-id="element-3136" data-mp="81c6se8rvr3m">
                  <div className="w-16 h-16 bg-[#007558]/10 rounded-full flex items-center justify-center mb-6" data-id="element-3137" data-mp="lz0stpekt4a9">
                    <CheckCircle size={32} className="text-[#007558]" data-id="element-3138" data-mp="h1sanotfh090" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-3139" data-mp="10nkd95k3n9kq">
                    You've added an additional admin
                  </h3>
                  <p className="text-gray-600 text-sm max-w-sm mx-auto" data-id="element-3140" data-mp="15j9fxhrf16l9">
                    We'll send an email to the address you provided with more
                    information on how to create a B2B admin account.
                  </p>
                </div>}
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Add Individual User Modal */}
      <AnimatePresence data-id="element-3141" data-mp="mnj8hf0prhzz">
        {showAddModal && <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={() => {
        setShowAddModal(false);
        setDepartment('');
        setCohort('');
        setNewDepartmentName('');
        setNewCohortName('');
      }} data-id="element-3142" data-mp="7xv9wljx2xfy">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="bg-white rounded-xl p-6 max-w-md w-full shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-3143" data-mp="3v4xbqxb4b84c">
              <div className="flex items-center justify-between mb-6" data-id="element-3144" data-mp="4h9551pw9ubu">
                <div className="flex items-center gap-3" data-id="element-3145" data-mp="4j3dzhnw5vzk">
                  <div className="w-10 h-10 rounded-full bg-[#30718D]/10 flex items-center justify-center" data-id="element-3146" data-mp="ggty2xgpfcx">
                    <UserPlus size={20} className="text-[#30718D]" data-id="element-3147" data-mp="3rtb8fimxjqof" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-3148" data-mp="3mw1k66ba1l26">
                    {addModalStep === 'form' ? `Add Learner` : 'Confirm Registration'}
                  </h2>
                </div>
                <button onClick={() => {
              setShowAddModal(false);
              setIsLicenseDropdownOpen(false);
              setLicenseSearch('');
              setDepartment('');
              setCohort('');
              setNewDepartmentName('');
              setNewCohortName('');
              setAddModalStep('form');
              setAcknowledgeChecked(false);
              setSelectedModalPathways([]);
              setSelectedLicenses([]);
            }} className="text-sm font-semibold text-gray-700 hover:text-gray-900 underline transition-colors" data-id="element-3149" data-mp="3cvr7cmt5mfnj">
                  Close
                </button>
              </div>

              {addModalStep === 'form' ? <>
                  <div className="space-y-4 mb-6" data-id="element-3150" data-mp="19pbqo4hli0vh">
                    <div data-id="element-3151" data-mp="19lxl6ndmxbjt">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3152" data-mp="1emv4526gy9md">
                        First Name <span className="text-[#DB3725]" data-id="element-3153" data-mp="1jelidj8j1hj2">*</span>
                      </label>
                      <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" placeholder="Enter first name" data-id="element-3154" data-mp="lyzc4aruh5vx" />
                    </div>
                    <div data-id="element-3155" data-mp="10qe9qvufovj7">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3156" data-mp="10rpdwwrsk5au">
                        Last Name <span className="text-[#DB3725]" data-id="element-3157" data-mp="15ozffasgg7f1">*</span>
                      </label>
                      <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" placeholder="Enter last name" data-id="element-3158" data-mp="1aq54mymwpcjt" />
                    </div>
                    <div data-id="element-3159" data-mp="1ohjrjgjxpxw5">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3160" data-mp="1oha9cf54sv10">
                        Email Address <span className="text-[#DB3725]" data-id="element-3161" data-mp="1tetl98ecwvps">*</span>
                      </label>
                      <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" placeholder="Enter email address" data-id="element-3162" data-mp="1ygj0l08m3vjo" />
                    </div>
                    <div data-id="element-3163" data-mp="3ivffff1vv2ba">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3164" data-mp="3iz37e9rojgnw">
                        Department <span className="text-[#DB3725]" data-id="element-3165" data-mp="3dzguy2joe4g5">*</span>
                      </label>
                      <div className="relative" ref={departmentDropdownRef} data-id="element-3166" data-mp="390vxubzq00vx">
                        <button type="button" onClick={() => {
                    setIsDepartmentDropdownOpen(open => !open);
                    setIsCreatingDepartment(false);
                  }} aria-haspopup="listbox" aria-expanded={isDepartmentDropdownOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-4 py-2 text-left text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isDepartmentDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-3167" data-mp="ag43ql8a5ddr">
                          <span className={department ? 'text-gray-700' : 'text-gray-400'} data-id="element-3168" data-mp="2iplikwg0vbny">{department || 'Select a department'}</span>
                          <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isDepartmentDropdownOpen ? 'rotate-180' : ''}`} data-id="element-3169" data-mp="2ms8aexcp0wl5" />
                        </button>
                        {isDepartmentDropdownOpen && <div role="listbox" aria-label="Select learner department" className="absolute z-20 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-3170" data-mp="1z09xya1icv6f">
                            {departments.map(item => <button key={item} type="button" role="option" aria-selected={department === item} onClick={() => {
                      setDepartment(item);
                      setIsDepartmentDropdownOpen(false);
                    }} className={`flex w-full items-center border-b border-gray-100 px-4 py-2.5 text-left text-sm transition-colors ${department === item ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-3171" data-mp="1q16e33uiobqv">
                              {item}
                            </button>)}
                            <div className="border-t border-gray-200 bg-gray-50 p-2" data-id="element-3172" data-mp="c3toa40ei036">
                              {isCreatingDepartment ? <div className="flex gap-2" data-id="element-3173" data-mp="7dd8wed0s4e6">
                                  <input autoFocus value={newDepartmentName} onChange={event => setNewDepartmentName(event.target.value)} onKeyDown={event => {
                          if (event.key === 'Enter') {
                            event.preventDefault();
                            handleCreateDepartment();
                          }
                        }} placeholder="New department name" className="min-w-0 flex-1 rounded-md border border-gray-300 px-2.5 py-2 text-sm focus:border-[#30718D] focus:outline-none focus:ring-2 focus:ring-[#30718D]/20" data-id="element-3174" data-mp="7b0idct74lpi" />
                                  <button type="button" onClick={handleCreateDepartment} disabled={!newDepartmentName.trim()} className="rounded-md bg-[#30718D] px-3 text-sm font-semibold text-white transition-colors hover:bg-[#265A70] disabled:cursor-not-allowed disabled:opacity-40" data-id="element-3175" data-mp="2sua878ubvhyq">Add</button>
                                </div> : <button type="button" onClick={() => setIsCreatingDepartment(true)} className="w-full rounded-md px-2.5 py-2 text-left text-sm font-semibold text-[#30718D] transition-colors hover:bg-[#D9EEF2]" data-id="element-3176" data-mp="33b459fay049p">
                                  + Create new department
                                </button>}
                            </div>
                          </div>}
                      </div>
                    </div>
                    <div data-id="element-3177" data-mp="2pa9uiq0f9r7v">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3178" data-mp="2pbl456gjtt6w">
                        Cohort <span className="font-normal text-gray-400" data-id="element-3179" data-mp="1ru4ckikonnf5">(optional)</span>
                      </label>
                      <div className="relative" ref={cohortDropdownRef} data-id="element-3180" data-mp="1wsxnc38l50bm">
                        <button type="button" onClick={() => {
                    setIsCohortDropdownOpen(open => !open);
                    setIsCreatingCohort(false);
                  }} aria-haspopup="listbox" aria-expanded={isCohortDropdownOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-4 py-2 text-left text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isCohortDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-3181" data-mp="1pazjofd34jgb">
                          <span className={cohort ? 'text-gray-700' : 'text-gray-400'} data-id="element-3182" data-mp="11jc0kjm2ecol">{cohort || 'Select a cohort'}</span>
                          <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isCohortDropdownOpen ? 'rotate-180' : ''}`} data-id="element-3183" data-mp="rn8zzi6v2m3r" />
                        </button>
                        {isCohortDropdownOpen && <div role="listbox" aria-label="Select learner cohort" className="absolute z-20 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-3184" data-mp="inlvgniu506h">
                            <button type="button" role="option" aria-selected={!cohort} onClick={() => {
                      setCohort('');
                      setIsCohortDropdownOpen(false);
                    }} className={`flex w-full items-center px-4 py-2.5 text-left text-sm transition-colors border-b border-gray-100 ${!cohort ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-3185" data-mp="d1bj7ql3yc68">
                              No cohort
                            </button>
                            {cohorts.map(item => <button key={item} type="button" role="option" aria-selected={cohort === item} onClick={() => {
                      setCohort(item);
                      setIsCohortDropdownOpen(false);
                    }} className={`flex w-full items-center px-4 py-2.5 text-left text-sm transition-colors border-b border-gray-100 ${cohort === item ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-3186" data-mp="hx93u93em4ot">
                              {item}
                            </button>)}
                            <div className="border-t border-gray-200 bg-gray-50 p-2" data-id="element-3187" data-mp="38xznig9z23k9">
                              {isCreatingCohort ? <div className="flex gap-2" data-id="element-3188" data-mp="34vmkw0qiulrp">
                                  <input autoFocus value={newCohortName} onChange={event => setNewCohortName(event.target.value)} onKeyDown={event => {
                          if (event.key === 'Enter') {
                            event.preventDefault();
                            handleCreateCohort();
                          }
                        }} placeholder="New cohort name" className="min-w-0 flex-1 rounded-md border border-gray-300 px-2.5 py-2 text-sm focus:border-[#30718D] focus:outline-none focus:ring-2 focus:ring-[#30718D]/20" data-id="element-3189" data-mp="34y8s1z9i2z9e" />
                                  <button type="button" onClick={handleCreateCohort} disabled={!newCohortName.trim()} className="rounded-md bg-[#30718D] px-3 text-sm font-semibold text-white transition-colors hover:bg-[#265A70] disabled:cursor-not-allowed disabled:opacity-40" data-id="element-3190" data-mp="heonsb20quv">Add</button>
                                </div> : <button type="button" onClick={() => setIsCreatingCohort(true)} className="w-full rounded-md px-2.5 py-2 text-left text-sm font-semibold text-[#30718D] transition-colors hover:bg-[#D9EEF2]" data-id="element-3191" data-mp="tj5zvv71oh8u">
                                  + Create new cohort
                                </button>}
                            </div>
                          </div>}
                      </div>
                    </div>
                    <div data-id="element-3192" data-mp="1ha1m8csqek8p">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3193" data-mp="1habek71913hk">
                        Licenses
                      </label>
                      <div className="relative" ref={licenseDropdownRef} data-id="element-3194" data-mp="3f1w7saij0p41">
                        <div className={`w-full px-4 py-2 border rounded-lg bg-white flex items-center justify-between cursor-text ${isLicenseDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]' : 'border-gray-300'}`} onClick={() => setIsLicenseDropdownOpen(true)} data-id="element-3195" data-mp="3j26exqi21lkh">
                          <input type="text" placeholder={selectedLicenses.length + selectedModalPathways.length > 0 ? `${selectedLicenses.length + selectedModalPathways.length} item${selectedLicenses.length + selectedModalPathways.length > 1 ? 's' : ''} selected — type to search...` : 'Search and select pathways or modules'} value={licenseSearch} onChange={e => {
                      setLicenseSearch(e.target.value);
                      if (!isLicenseDropdownOpen) setIsLicenseDropdownOpen(true);
                    }} onFocus={() => setIsLicenseDropdownOpen(true)} className="flex-1 text-sm bg-transparent outline-none placeholder-gray-400" data-id="element-3196" data-mp="31rauc0x7nnso" />
                          <ChevronDown size={16} className={`text-gray-400 transition-transform flex-shrink-0 ml-2 ${isLicenseDropdownOpen ? 'rotate-180' : ''}`} data-id="element-3197" data-mp="29ytnpcwnu48l" />
                        </div>
                        {isLicenseDropdownOpen && <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-72 overflow-hidden" data-id="element-3198" data-mp="yb2ojiym2oic">
                            <div className="max-h-72 overflow-y-auto" data-id="element-3199" data-mp="1c391kw6gwfdk">
                              {/* Pathways Section */}
                              {pathwayData.filter(p => p.name.toLowerCase().includes(licenseSearch.toLowerCase())).length > 0 && <>
                                  <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-3200" data-mp="1h1u1euht4x1h">
                                    <span className="text-xs font-medium text-black uppercase tracking-wide" data-id="element-3201" data-mp="1v01x6z33xsb2">
                                      Pathways
                                    </span>
                                    <button type="button" onClick={e => {
                            e.stopPropagation();
                            selectAllModalPathways();
                          }} className="text-xs font-medium text-[#30718D] hover:text-[#265a70] transition-colors" data-id="element-3202" data-mp="o3m0rl8mmcj">
                                      {selectedModalPathways.length === pathwayData.length ? 'Deselect all' : 'Select all'}
                                    </button>
                                  </div>
                                  {pathwayData.filter(p => p.name.toLowerCase().includes(licenseSearch.toLowerCase())).map(pathway => <label key={pathway.name} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100" data-id="element-3203" data-mp="1okbipmvxdg50">
                                        <input type="checkbox" checked={selectedModalPathways.includes(pathway.name)} onChange={() => toggleModalPathway(pathway.name)} className="w-4 h-4 rounded border-gray-400 text-[#30718D] focus:ring-[#30718D]" data-id="element-3204" data-mp="1fkwr2k40uzix" />
                                        <div data-id="element-3205" data-mp="39z7f4qcslpnn">
                                          <div className="text-sm font-semibold text-gray-900" data-id="element-3206" data-mp="3e0j9182p8x1n">
                                            {pathway.name}
                                          </div>
                                          <div className="text-xs text-gray-500" data-id="element-3207" data-mp="lrz5rnoys53w">
                                            {pathway.skillCount} skills
                                          </div>
                                        </div>
                                      </label>)}
                                </>}

                              {/* Individual Skills Section */}
                              {availableSkills.filter(skill => skill.toLowerCase().includes(licenseSearch.toLowerCase())).length > 0 && <>
                                  <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-3208" data-mp="10o6rwtjxnglt">
                                    <span className="text-xs font-medium text-black uppercase tracking-wide" data-id="element-3209" data-mp="vou4o7p5g7ip">
                                      Individual Skills
                                    </span>
                                    <button type="button" onClick={e => {
                            e.stopPropagation();
                            selectAllModalSkills();
                          }} className="text-xs font-medium text-[#30718D] hover:text-[#265a70] transition-colors" data-id="element-3210" data-mp="1vqgtylj1d7ik">
                                      {selectedLicenses.length === availableSkills.length ? 'Deselect all' : 'Select all'}
                                    </button>
                                  </div>
                                  {availableSkills.filter(skill => skill.toLowerCase().includes(licenseSearch.toLowerCase())).map(skill => <label key={skill} className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0" data-id="element-3211" data-mp="2of604yyy8316">
                                        <input type="checkbox" checked={selectedLicenses.includes(skill)} onChange={() => toggleLicense(skill)} className="w-4 h-4 rounded border-gray-400 text-[#30718D] focus:ring-[#30718D]" data-id="element-3212" data-mp="2tgbu104chwca" />
                                        <span className="text-sm text-gray-700" data-id="element-3213" data-mp="2oryhlzkqpmno">
                                          {skill}
                                        </span>
                                      </label>)}
                                </>}

                              {pathwayData.filter(p => p.name.toLowerCase().includes(licenseSearch.toLowerCase())).length === 0 && availableSkills.filter(skill => skill.toLowerCase().includes(licenseSearch.toLowerCase())).length === 0 && <p className="px-4 py-3 text-sm text-gray-400" data-id="element-3214" data-mp="25vf2mtn994j7">
                                    No results found
                                  </p>}
                            </div>
                          </div>}
                      </div>
                      {(selectedModalPathways.length > 0 || selectedLicenses.length > 0) && <div className="flex flex-wrap gap-1.5 mt-2 max-h-24 overflow-y-auto" data-id="element-3215" data-mp="3r6f6o9ze3mux">
                          {selectedModalPathways.map(pathway => <span key={pathway} className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium" data-id="element-3216" data-mp="3m6j3ue2fi1gy">
                              <span className="text-[10px] font-semibold uppercase tracking-wide opacity-70 mr-0.5" data-id="element-3217" data-mp="1cywcd6nq93dl">
                                Pathway
                              </span>
                              {pathway}
                              <button type="button" onClick={() => toggleModalPathway(pathway)} className="hover:text-[#DB3725] transition-colors" data-id="element-3218" data-mp="13z9cwqek67n6">
                                ×
                              </button>
                            </span>)}
                          {selectedLicenses.map(skill => <span key={skill} className="inline-flex items-center gap-1 px-2 py-1 bg-[#30718D]/10 text-[#30718D] rounded text-xs font-medium" data-id="element-3219" data-mp="1hysk9gzjpeyf">
                              {skill}
                              <button type="button" onClick={() => toggleLicense(skill)} className="hover:text-[#DB3725] transition-colors" data-id="element-3220" data-mp="2am4yn3vjyggn">
                                ×
                              </button>
                            </span>)}
                        </div>}
                    </div>
                  </div>

                  <div className="flex gap-3" data-id="element-3221" data-mp="2kblj3dzyd5q0">
                    <button onClick={() => {
                setShowAddModal(false);
                setIsLicenseDropdownOpen(false);
                setDepartment('');
                setCohort('');
                setNewDepartmentName('');
                setNewCohortName('');
                setAddModalStep('form');
                setAcknowledgeChecked(false);
                setSelectedModalPathways([]);
                setSelectedLicenses([]);
              }} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-3222" data-mp="2fb79hripdnpv">
                      Cancel
                    </button>
                    <button onClick={() => {
                setIsLicenseDropdownOpen(false);
                setLicenseSearch('');
                setAddModalStep('confirm');
              }} disabled={!firstName.trim() || !lastName.trim() || !email.trim() || !department} className={`flex-1 px-4 py-2 rounded-lg transition-colors font-medium shadow-sm ${firstName.trim() && lastName.trim() && email.trim() && department ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-3223" data-mp="1ml8kfw4idql7">
                      Next
                    </button>
                  </div>
                </> : <>
                  {/* Confirmation Screen */}
                  <p className="text-sm text-gray-600 mb-4" data-id="element-3224" data-mp="3fim74hhh1tji">
                    Please ensure all learner information provided is accurate.
                  </p>

                  <div className="flex items-center gap-4 text-xs mb-4" data-id="element-3225" data-mp="3kgnngunijera">
                    {(() => {
                const totalPathwaySkills = selectedModalPathways.reduce((sum, name) => sum + (pathwayData.find(p => p.name === name)?.skillCount || 0), 0);
                const totalSkills = totalPathwaySkills + selectedLicenses.length;
                return <>
                          <span className="text-gray-500" data-id="element-3226" data-mp="1q5u09ka08m96">
                            Licenses to be registered:{' '}
                            <span className="font-bold text-[#30718D]" data-id="element-3227" data-mp="1l8trv2pon7ew">
                              {totalSkills}
                            </span>
                          </span>
                          <span className="text-gray-300" data-id="element-3228" data-mp="1u5ud50hggpe4">|</span>
                          <span className="text-gray-500" data-id="element-3229" data-mp="293eelxf582fj">
                            Remaining:{' '}
                            <span className="font-bold text-gray-900" data-id="element-3230" data-mp="244a2axwx9okz">
                              {190 - totalSkills}
                            </span>
                          </span>
                        </>;
              })()}
                  </div>

                  <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 mb-5" data-id="element-3231" data-mp="2ruxg1ztir8fg">
                    <div className="flex items-center gap-3 mb-3" data-id="element-3232" data-mp="2rskxpljumw1v">
                      <div className="w-10 h-10 rounded-full bg-[#30718D] flex items-center justify-center text-white text-sm font-bold" data-id="element-3233" data-mp="2mxe2l24nazok">
                        {firstName.charAt(0).toUpperCase()}
                        {lastName.charAt(0).toUpperCase()}
                      </div>
                      <div data-id="element-3234" data-mp="2wincqzposk6r">
                        <p className="text-sm font-semibold text-gray-900" data-id="element-3235" data-mp="2wljcmtl3hixu">
                          {firstName} {lastName}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-3236" data-mp="2nqv50ws1rp5v">{email}</p>
                        <div className="mt-1 flex flex-wrap gap-1.5" data-id="element-3237" data-mp="2shv68e878te6">
                          <span className="text-xs font-medium text-[#30718D]" data-id="element-3238" data-mp="2sjy39i7rrmse">{department}</span>
                          {cohort && <span className="rounded bg-purple-50 px-1.5 py-0.5 text-xs font-medium text-purple-700" data-id="element-3239" data-mp="2dr4baxbb9e6u">{cohort}</span>}
                        </div>
                      </div>
                    </div>

                    {selectedModalPathways.length > 0 && <div className="pt-3 border-t border-gray-200" data-id="element-3240" data-mp="28st12lh3t1o3">
                        <p className="text-xs font-medium text-gray-500 uppercase mb-2" data-id="element-3241" data-mp="27x999v8d93yc">
                          Assigned Pathways (
                          {selectedModalPathways.reduce((sum, name) => sum + (pathwayData.find(p => p.name === name)?.skillCount || 0), 0)}{' '}
                          skills)
                        </p>
                        <div className="flex flex-wrap gap-1.5" data-id="element-3242" data-mp="1tz1d3pj5m6o8">
                          {selectedModalPathways.map(pathway => <span key={pathway} className="inline-flex items-center gap-1 px-2.5 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium" data-id="element-3243" data-mp="2rkysvf65fxwh">
                              <span className="text-[10px] font-semibold uppercase tracking-wide opacity-70 mr-0.5" data-id="element-3244" data-mp="2hv5ek6emh4oj">
                                Pathway
                              </span>
                              {pathway}
                            </span>)}
                        </div>
                      </div>}

                    {selectedLicenses.length > 0 && <div className={`pt-3 ${selectedModalPathways.length > 0 ? 'mt-3' : ''} border-t border-gray-200`} data-id="element-3245" data-mp="35j6jl5cle2z7">
                        <p className="text-xs font-medium text-gray-500 uppercase mb-2" data-id="element-3246" data-mp="3hvirzm8na3bu">
                          Assigned Skills ({selectedLicenses.length})
                        </p>
                        <div className="flex flex-wrap gap-1.5" data-id="element-3247" data-mp="3mwy9x5fiztq0">
                          {selectedLicenses.map(skill => <span key={skill} className="px-2.5 py-1 bg-[#30718D]/10 text-[#30718D] rounded text-xs font-medium" data-id="element-3248" data-mp="3rrc08tfbzant">
                              {skill}
                            </span>)}
                        </div>
                      </div>}
                  </div>

                  <div className="bg-amber-50 rounded-lg p-4 mb-5 border border-amber-100" data-id="element-3249" data-mp="9gh3k88pc7gb">
                    <p className="text-sm text-gray-700 leading-relaxed" data-id="element-3250" data-mp="ee0izbh4yq9u">
                      Once you click submit, the learner will receive an email
                      with instructions to create a password and complete their
                      registration.
                    </p>
                  </div>

                  <label className="flex items-start gap-3 mb-6 cursor-pointer" data-id="element-3251" data-mp="2ke03guhr2eqr">
                    <input type="checkbox" checked={acknowledgeChecked} onChange={e => setAcknowledgeChecked(e.target.checked)} className="w-4 h-4 rounded border-gray-300 text-[#30718D] focus:ring-[#30718D] mt-0.5" data-id="element-3252" data-mp="2fium88zalo90" />
                    <span className="text-sm text-gray-700" data-id="element-3253" data-mp="2oflialduh33l">
                      I acknowledge that I have the authority to share the
                      information of the learner I provided.
                    </span>
                  </label>

                  <div className="flex gap-3" data-id="element-3254" data-mp="3c69141patd4x">
                    <button onClick={() => setAddModalStep('form')} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-3255" data-mp="3c567vn4i6ylu">
                      Back
                    </button>
                    <button onClick={handleAddUser} disabled={!acknowledgeChecked} className={`flex-1 px-4 py-2 rounded-lg transition-colors font-medium shadow-sm ${acknowledgeChecked ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-3256" data-mp="1dsfnunhobprk">
                      Submit
                    </button>
                  </div>
                </>}
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Bulk Upload Modal */}
      <AnimatePresence data-id="element-3257" data-mp="jzzzyr10lfm1">
        {showBulkModal && <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={handleCloseBulkModal} data-id="element-3258" data-mp="jy6s58eo0pcg">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="bg-white rounded-xl p-6 w-full shadow-2xl max-h-[90vh] overflow-y-auto max-w-lg" onClick={e => e.stopPropagation()} data-id="element-3259" data-mp="az1ue4axh01c">
              <div className="flex items-center justify-between mb-6" data-id="element-3260" data-mp="a8vd8hiib48q">
                <div className="flex items-center gap-3" data-id="element-3261" data-mp="5b3bywvz25rv">
                  <div className="w-10 h-10 rounded-full bg-[#007558]/10 flex items-center justify-center" data-id="element-3262" data-mp="5bmv2gxcz07h">
                    <Upload size={20} className="text-[#007558]" data-id="element-3263" data-mp="dtk7al41i0v" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-3264" data-mp="3sf9kxyq6mhyo">
                    Bulk Upload Learners
                  </h2>
                </div>
                <button onClick={handleCloseBulkModal} className="text-sm font-semibold text-gray-700 hover:text-gray-900 underline transition-colors" data-id="element-3265" data-mp="3ipgch6lc6iyn">
                  Close
                </button>
              </div>

              {bulkUploadStep === 'upload' ? <>
                  <div className="mb-6" data-id="element-3266" data-mp="34pytj7uq1zx7">
                    <div onClick={handleSimulateBulkUpload} className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-[#30718D] transition-colors cursor-pointer" data-id="element-3267" data-mp="34oxaag3jy74e">
                      <Upload size={48} className="mx-auto text-gray-400 mb-4" data-id="element-3268" data-mp="1f7ryktuafe5e" />
                      <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-3269" data-mp="1k7eitn8j9unp">
                        Click to upload or drag and drop
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-3270" data-mp="1o7f2pneeiy25">
                        CSV file with columns: First Name, Last Name, Email, Department
                      </p>
                    </div>
                  </div>

                  <div className="bg-[#30718D]/5 rounded-lg p-4 mb-6" data-id="element-3271" data-mp="10jnnaaxke4wn">
                    <div className="flex items-start gap-3" data-id="element-3272" data-mp="10huhexurzopp">
                      <AlertCircle size={20} className="text-[#30718D] mt-0.5" data-id="element-3273" data-mp="15hyusf0e03bp" />
                      <div data-id="element-3274" data-mp="1aa05vxltjo05">
                        <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-3275" data-mp="1abb8hu3j2ppo">
                          CSV Format Requirements
                        </p>
                        <p className="text-xs text-gray-600" data-id="element-3276" data-mp="ht5uy7gn9bbt">
                          Your CSV must include headers: First Name, Last Name,
                          Email, Department. Each row represents one learner.
                        </p>
                      </div>
                    </div>
                  </div>

                  <button onClick={handleDownloadCsvTemplate} className="w-full mb-3 px-4 py-2 border border-[#30718D] bg-white text-[#30718D] rounded-lg hover:bg-[#30718D]/5 transition-colors font-medium flex items-center justify-center gap-2" data-id="element-3277" data-mp="1tvlqasmiyd5x">
                    <Download size={16} data-id="element-3278" data-mp="127btyh5c1yd0" />
                    Download CSV Template
                  </button>

                  <div className="flex gap-3" data-id="element-3279" data-mp="1b65om1z3senx">
                    <button onClick={handleCloseBulkModal} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-3280" data-mp="1b6ymedg33ttx">
                      Cancel
                    </button>
                    <button onClick={handleSimulateBulkUpload} className="flex-1 px-4 py-2 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-colors font-medium shadow-sm" data-id="element-3281" data-mp="2mn5ekqxzahes">
                      Upload & Import
                    </button>
                  </div>
                </> : <>
                  <div className="bg-[#DB3725]/5 border border-[#DB3725]/20 rounded-lg p-4 mb-6" data-id="element-3282" data-mp="2u2iibvcqqsez">
                    <p className="text-sm text-[#DB3725] font-medium" data-id="element-3283" data-mp="2g7evf1fuph2e">
                      {bulkErrorEntries.length} learner(s) have validation
                      errors. Please correct the errors below and click "Fix &
                      Add" for each learner.
                    </p>
                  </div>

                  <div className="space-y-4 mb-6" data-id="element-3284" data-mp="2z47vbgjixg5p">
                    {bulkErrorEntries.map(entry => <div key={entry.id} className="border border-gray-200 rounded-lg p-4 bg-white" data-id="element-3285" data-mp="3431816qzl34t">
                        <div className="flex items-center justify-between mb-4" data-id="element-3286" data-mp="3rsls5syvm6fo">
                          <h3 className="font-bold text-gray-900" data-id="element-3287" data-mp="3rqiuqnve9b0x">
                            Row {entry.row}
                          </h3>
                          <div className="flex items-center gap-2" data-id="element-3288" data-mp="1whcbz1prk5v0">
                            {entry.fixed && <span className="flex items-center gap-1 text-sm font-medium text-[#007558] px-3 py-1.5 bg-[#007558]/10 rounded-md" data-id="element-3289" data-mp="1rqm51k1ovuy7">
                                <CheckCircle size={16} data-id="element-3290" data-mp="1mrsqdoao1xwg" />
                                Fixed
                              </span>}
                            <button onClick={() => handleRemoveBulkError(entry.id)} className="px-3 py-1.5 bg-[#DB3725] text-white text-sm font-medium rounded-md hover:bg-[#c02f1f] transition-colors" data-id="element-3291" data-mp="1inuwbs077da9">
                              Remove
                            </button>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-3292" data-mp="21gyo17tuvg28">
                          <div data-id="element-3293" data-mp="uztsuxhvmn1p">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3294" data-mp="v0v2cxj8v1hb">
                              First Name
                            </label>
                            <input type="text" value={entry.firstName} onChange={e => handleBulkErrorChange(entry.id, 'firstName', e.target.value)} disabled={entry.fixed} className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#30718D] text-sm ${entry.errors?.firstName ? 'border-[#DB3725]' : 'border-gray-300'} ${entry.fixed ? 'bg-gray-50 text-gray-500' : ''}`} data-id="element-3295" data-mp="31ovppglj34ec" />
                            {entry.errors?.firstName && <p className="text-[#DB3725] text-xs mt-1 flex items-center gap-1" data-id="element-3296" data-mp="3ke208gc64pp2">
                                <X size={12} data-id="element-3297" data-mp="3pcn2elazdjg5" /> {entry.errors.firstName}
                              </p>}
                          </div>
                          <div data-id="element-3298" data-mp="3uaww0rh24bzn">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3299" data-mp="29qnzyoezxb8">
                              Last Name
                            </label>
                            <input type="text" value={entry.lastName} onChange={e => handleBulkErrorChange(entry.id, 'lastName', e.target.value)} disabled={entry.fixed} className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#30718D] text-sm ${entry.errors?.lastName ? 'border-[#DB3725]' : 'border-gray-300'} ${entry.fixed ? 'bg-gray-50 text-gray-500' : ''}`} data-id="element-3300" data-mp="201ct5uivoeqm" />
                            {entry.errors?.lastName && <p className="text-[#DB3725] text-xs mt-1 flex items-center gap-1" data-id="element-3301" data-mp="1kn0wrpzehu6w">
                                <X size={12} data-id="element-3302" data-mp="28d4s7a2fqnmt" /> {entry.errors.lastName}
                              </p>}
                          </div>
                          <div className="sm:col-span-2" data-id="element-3303" data-mp="2daoft0l0wcrf">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3304" data-mp="1zcgn54v0rxm2">
                              Email
                            </label>
                            <input type="email" value={entry.email} onChange={e => handleBulkErrorChange(entry.id, 'email', e.target.value)} disabled={entry.fixed} className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#30718D] text-sm ${entry.errors?.email ? 'border-[#DB3725]' : 'border-gray-300'} ${entry.fixed ? 'bg-gray-50 text-gray-500' : ''}`} data-id="element-3305" data-mp="249gk8q9w5q11" />
                            {entry.errors?.email && <p className="text-[#DB3725] text-xs mt-1 flex items-center gap-1" data-id="element-3306" data-mp="gfv58nft6s4i">
                                <X size={12} data-id="element-3307" data-mp="uaxki16jpttz" /> {entry.errors.email}
                              </p>}
                          </div>
                          <div className="sm:col-span-2" data-id="element-3308" data-mp="1o30t6hjyyhk">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3309" data-mp="1mjlbi3q0rgu">
                              Department
                            </label>
                            <div className="relative" data-id="element-3310" data-mp="bf7f03zemfbc">
                              <select value={entry.department || ''} onChange={e => handleBulkErrorChange(entry.id, 'department', e.target.value)} disabled={entry.fixed} className={`w-full appearance-none rounded-md border bg-white py-2 pl-3 pr-9 text-sm transition-colors focus:border-[#30718D] focus:outline-none focus:ring-2 focus:ring-[#30718D]/20 ${entry.errors?.department ? 'border-[#DB3725]' : 'border-gray-300'} ${entry.fixed ? 'cursor-not-allowed bg-gray-50 text-gray-500' : 'text-gray-700'}`} data-id="element-3311" data-mp="6nz6da5wexz8">
                                <option value="" data-id="element-3312" data-mp="1nrckzj58og2r">Select a department</option>
                                {departments.map(item => <option key={item} value={item} data-id="element-3313" data-mp="1rt7ngqywozi4">{item}</option>)}
                              </select>
                              <ChevronDown size={16} aria-hidden="true" className={`pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 ${entry.fixed ? 'text-gray-300' : 'text-gray-400'}`} data-id="element-3314" data-mp="v3guiw69jkef" />
                            </div>
                            {entry.errors?.department && <p className="text-[#DB3725] text-xs mt-1 flex items-center gap-1" data-id="element-3315" data-mp="1926see0wpo3u">
                                <X size={12} data-id="element-3316" data-mp="2fiae2obiq2or" /> {entry.errors.department}
                              </p>}
                          </div>
                        </div>
                      </div>)}
                    {bulkErrorEntries.length === 0 && <div className="text-center py-8 text-gray-500" data-id="element-3317" data-mp="2uljvqcux9mcw">
                        All errors resolved. You can now submit.
                      </div>}
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-gray-200" data-id="element-3318" data-mp="2kuz110idd1z9">
                    <button onClick={() => setBulkUploadStep('upload')} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-3319" data-mp="2guf3vwxspyd4">
                      Cancel
                    </button>
                    <button onClick={handleSubmitBulkErrors} className="px-6 py-2 bg-[#111827] text-white rounded-lg hover:bg-gray-800 transition-colors font-medium shadow-sm" data-id="element-3320" data-mp="26ueh210px046">
                      Submit All (
                      {bulkErrorEntries.filter(e => e.fixed || Object.keys(e.errors || {}).length === 0).length}
                      )
                    </button>
                  </div>
                </>}
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Generate Link Modal */}
      <AnimatePresence data-id="element-3321" data-mp="34rvgp4josrk">
        {showLinkModal && <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={() => setShowLinkModal(false)} data-id="element-3322" data-mp="867jmq20rfe6">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="bg-white rounded-xl p-6 max-w-lg w-full shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-3323" data-mp="3qbap4bvwdtf4">
              <div className="flex items-center justify-between mb-6" data-id="element-3324" data-mp="36lqmxkabfjg2">
                <div className="flex items-center gap-3" data-id="element-3325" data-mp="3bn7oli0mj9xp">
                  <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center" data-id="element-3326" data-mp="2xmddgrm6yuvc">
                    <Link2 size={20} className="text-purple-600" data-id="element-3327" data-mp="32m9fwmf8qe8s" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-3328" data-mp="2izod6nk48dnw">
                    Learner Registration Link Generated
                  </h2>
                </div>
                <button onClick={() => setShowLinkModal(false)} className="text-sm font-semibold text-gray-700 hover:text-gray-900 underline transition-colors" data-id="element-3329" data-mp="2e3g49rwihgp6">
                  Close
                </button>
              </div>

              <div className="mb-6" data-id="element-3330" data-mp="31yipzr00r41f">
                <p className="text-sm text-gray-600 mb-4" data-id="element-3331" data-mp="31xhhnuae0vne">
                  Share this link with learners to allow them to self-register
                  for the license(s) you select.
                </p>

                {/* Licenses Multi-Select */}
                <div className="mb-4" data-id="element-3332" data-mp="36p8wx8o3fey8">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3333" data-mp="36qalmfy17zyf">
                    Licenses <span className="text-[#DB3725]" data-id="element-3334" data-mp="3kqbnnyq19dfh">*</span>
                  </label>
                  <div className="relative" ref={linkLicenseDropdownRef} data-id="element-3335" data-mp="3fri7fyjd38bm">
                    <div className={`w-full px-4 py-2 border rounded-lg bg-white flex items-center justify-between cursor-text ${isLinkLicenseDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]' : 'border-gray-300'}`} onClick={() => setIsLinkLicenseDropdownOpen(true)} data-id="element-3336" data-mp="2ddasqnned0nd">
                      <input type="text" placeholder={linkLicenses.length + linkPathways.length > 0 ? `${linkLicenses.length + linkPathways.length} item${linkLicenses.length + linkPathways.length > 1 ? 's' : ''} selected — type to search...` : 'Search and select pathways or modules'} value={linkLicenseSearch} onChange={e => {
                    setLinkLicenseSearch(e.target.value);
                    if (!isLinkLicenseDropdownOpen) setIsLinkLicenseDropdownOpen(true);
                  }} onFocus={() => setIsLinkLicenseDropdownOpen(true)} className="flex-1 text-sm bg-transparent outline-none placeholder-gray-400" data-id="element-3337" data-mp="2mbwawhoyidnm" />
                      <ChevronDown size={16} className={`text-gray-400 transition-transform flex-shrink-0 ml-2 ${isLinkLicenseDropdownOpen ? 'rotate-180' : ''}`} data-id="element-3338" data-mp="1fp0v0kun8z22" />
                    </div>
                    {isLinkLicenseDropdownOpen && <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-72 overflow-hidden" data-id="element-3339" data-mp="13et2zldofq6l">
                        <div className="max-h-72 overflow-y-auto" data-id="element-3340" data-mp="ydvkt8so2w53">
                          {/* Pathways Section */}
                          {pathwayData.filter(p => p.name.toLowerCase().includes(linkLicenseSearch.toLowerCase())).length > 0 && <>
                              <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-3341" data-mp="1m6lt981d2xam">
                                <span className="text-xs font-medium text-black uppercase tracking-wide" data-id="element-3342" data-mp="1i24a9b2tso0w">
                                  Pathways
                                </span>
                                <button type="button" onClick={e => {
                          e.stopPropagation();
                          selectAllLinkPathways();
                        }} className="text-xs font-medium text-[#30718D] hover:text-[#265a70] transition-colors" data-id="element-3343" data-mp="6pk2ec4ks55j">
                                  {linkPathways.length === pathwayData.length ? 'Deselect all' : 'Select all'}
                                </button>
                              </div>
                              {pathwayData.filter(p => p.name.toLowerCase().includes(linkLicenseSearch.toLowerCase())).map(pathway => <label key={pathway.name} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100" data-id="element-3344" data-mp="2ki6g1pxdd080">
                                    <input type="checkbox" checked={linkPathways.includes(pathway.name)} onChange={() => toggleLinkPathway(pathway.name)} className="w-4 h-4 rounded border-gray-400 text-[#30718D] focus:ring-[#30718D]" data-id="element-3345" data-mp="2pjcf05hmhjpz" />
                                    <div data-id="element-3346" data-mp="33h0uexsx7ynn">
                                      <div className="text-sm font-semibold text-gray-900" data-id="element-3347" data-mp="33f7o5jm7zgg6">
                                        {pathway.name}
                                      </div>
                                      <div className="text-xs text-gray-500" data-id="element-3348" data-mp="wr7cvyx7n3zi">
                                        {pathway.skillCount} skills
                                      </div>
                                    </div>
                                  </label>)}
                            </>}

                          {/* Individual Skills Section */}
                          {availableSkills.filter(skill => skill.toLowerCase().includes(linkLicenseSearch.toLowerCase())).length > 0 && <>
                              <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-3349" data-mp="8wxk9xzqo7mx">
                                <span className="text-xs font-medium text-black uppercase tracking-wide" data-id="element-3350" data-mp="hvre5gloqjws">
                                  Individual Skills
                                </span>
                                <button type="button" onClick={e => {
                          e.stopPropagation();
                          selectAllLinkSkills();
                        }} className="text-xs font-medium text-[#30718D] hover:text-[#265a70] transition-colors" data-id="element-3351" data-mp="1tay6ffrxdcrs">
                                  {linkLicenses.length === availableSkills.length ? 'Deselect all' : 'Select all'}
                                </button>
                              </div>
                              {availableSkills.filter(skill => skill.toLowerCase().includes(linkLicenseSearch.toLowerCase())).map(skill => <label key={skill} className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0" data-id="element-3352" data-mp="21ybq2dic21cw">
                                    <input type="checkbox" checked={linkLicenses.includes(skill)} onChange={() => toggleLinkLicense(skill)} className="w-4 h-4 rounded border-gray-400 text-[#30718D] focus:ring-[#30718D]" data-id="element-3353" data-mp="2bpol1dzfh7n5" />
                                    <span className="text-sm text-gray-700" data-id="element-3354" data-mp="2kotj6j72uyys">
                                      {skill}
                                    </span>
                                  </label>)}
                            </>}

                          {pathwayData.filter(p => p.name.toLowerCase().includes(linkLicenseSearch.toLowerCase())).length === 0 && availableSkills.filter(skill => skill.toLowerCase().includes(linkLicenseSearch.toLowerCase())).length === 0 && <p className="px-4 py-3 text-sm text-gray-400" data-id="element-3355" data-mp="2vb8ad1q2e9n5">
                                No results found
                              </p>}
                        </div>
                      </div>}
                  </div>
                  {(linkPathways.length > 0 || linkLicenses.length > 0) && <div className="flex flex-wrap gap-1.5 mt-2 max-h-24 overflow-y-auto" data-id="element-3356" data-mp="27n88p6r7syts">
                      {linkPathways.map(pathway => <span key={pathway} className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium" data-id="element-3357" data-mp="2bottde9zqhej">
                          <span className="text-[10px] font-semibold uppercase tracking-wide opacity-70 mr-0.5" data-id="element-3358" data-mp="22n2pmez0gknb">
                            Pathway
                          </span>
                          {pathway}
                          <button type="button" onClick={() => toggleLinkPathway(pathway)} className="hover:text-[#DB3725] transition-colors" data-id="element-3359" data-mp="3g5glqq9ikg5">
                            ×
                          </button>
                        </span>)}
                      {linkLicenses.map(skill => <span key={skill} className="inline-flex items-center gap-1 px-2 py-1 bg-[#30718D]/10 text-[#30718D] rounded text-xs font-medium" data-id="element-3360" data-mp="3qja8o7grzfxb">
                          {skill}
                          <button type="button" onClick={() => toggleLinkLicense(skill)} className="hover:text-[#DB3725] transition-colors" data-id="element-3361" data-mp="n2a43gm31neb">
                            ×
                          </button>
                        </span>)}
                    </div>}
                </div>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-3362" data-mp="32wtzr2krq8mm">
                  <div className="flex items-center gap-2 mb-2" data-id="element-3363" data-mp="2xvo6n3n74jck">
                    <span className="text-xs font-medium text-gray-500 uppercase" data-id="element-3364" data-mp="2nt0ylsw2fsic">
                      Registration Link
                    </span>
                    <span className={`text-xs px-2 py-0.5 rounded ${userType === 'learners' ? 'bg-[#30718D]/10 text-[#30718D]' : 'bg-purple-100 text-purple-700'}`} data-id="element-3365" data-mp="2srvh0tq4ff1x">
                      Learner
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-3366" data-mp="36j8ubpxfrgoi">
                    <code className="flex-1 text-sm text-gray-900 break-all" data-id="element-3367" data-mp="36l388kaai8j3">
                      {generatedLink}
                    </code>
                    <button onClick={handleCopyLink} className="p-2 text-[#30718D] hover:bg-[#30718D]/10 rounded-lg transition-colors flex-shrink-0" data-id="element-3368" data-mp="3ggn3r5kxz57b">
                      {linkCopied ? <CheckCircle size={18} data-id="element-3369" data-mp="3ldx0756r0h4n" /> : <Copy size={18} data-id="element-3370" data-mp="1m3f512tui9ge" />}
                    </button>
                  </div>
                </div>

                {linkCopied && <motion.p initial={{
              opacity: 0,
              y: -10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="text-sm text-[#007558] mt-2 flex items-center gap-1" data-id="element-3371" data-mp="1r39vx6dmez1g">
                    <CheckCircle size={14} data-id="element-3372" data-mp="3cmdcujp35s38" />
                    Link copied to clipboard!
                  </motion.p>}
              </div>

              <div className="bg-purple-50 rounded-lg p-4 mb-6" data-id="element-3373" data-mp="3lkfkhi3brizh">
                <div className="flex items-start gap-3" data-id="element-3374" data-mp="3lj4fxg22277b">
                  <Clock size={20} className="text-purple-600 mt-0.5" data-id="element-3375" data-mp="2xw60mlpo95az" />
                  <div data-id="element-3376" data-mp="2tuayxg3twpwo">
                    <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-3377" data-mp="2tv2krz7mj99r">
                      Link Expiration
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-3378" data-mp="37n0o1tenmay0">
                      This link will expire in 7 days. You can generate a new
                      link at any time.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-3" data-id="element-3379" data-mp="2a50n4d77ep3u">
                <button onClick={() => {
              setShowLinkModal(false);
              setIsLinkLicenseDropdownOpen(false);
              setLinkLicenseSearch('');
              setLinkPathways([]);
              setLinkLicenses([]);
            }} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-3380" data-mp="pnrfeq6mznke">
                  Close
                </button>
                <button onClick={handleGenerateLink} disabled={linkLicenses.length === 0 && linkPathways.length === 0} className={`flex-1 px-4 py-2 rounded-lg transition-colors font-medium shadow-sm ${linkLicenses.length > 0 || linkPathways.length > 0 ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-3381" data-mp="19bgzeb8c0jj2">
                  Generate New Link
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Floating Action Bar for Bulk Assignment */}
      <AnimatePresence data-id="element-3382" data-mp="3p0s3gyg1uha1">
        {selectedCount > 0 && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} data-phoebe-tour="assignment-bar" className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] px-4 py-4 sm:px-6 lg:px-8" data-id="element-3383" data-mp="351a35mj8om9z">
            <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-4" data-id="element-3384" data-mp="2r7j0my3xe2nr">
              {/* Left side: badge + dropdowns */}
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 flex-1" data-id="element-3385" data-mp="2haedow29a35w">
                <div className="bg-[#30718D]/10 text-[#30718D] px-3 py-2 rounded-lg font-semibold text-sm whitespace-nowrap text-center sm:text-left" data-id="element-3386" data-mp="2dadpwkt9ofm6">
                  {selectedLearnerLabel} selected
                </div>

                {/* Assign Skills Dropdown */}
                <div className="relative flex-1 sm:max-w-[240px]" ref={bulkSkillDropdownRef} data-id="element-3387" data-mp="6iuzkxbmhhgh">
                  <button onClick={() => {
                if (noLicensesAvailable) {
                  setShowNoLicenseToast(true);
                  setTimeout(() => setShowNoLicenseToast(false), 3000);
                  return;
                }
                setIsBulkSkillDropdownOpen(!isBulkSkillDropdownOpen);
                setIsBulkPathwayDropdownOpen(false);
              }} className={`w-full px-4 py-2 border rounded-lg flex items-center justify-between text-sm ${noLicensesAvailable ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed' : isBulkSkillDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 bg-white' : 'border-gray-300 hover:border-gray-400 bg-white'}`} data-id="element-3388" data-mp="e35lz0kpgcpw">
                    <span className="truncate text-gray-700" data-id="element-3389" data-mp="942hbh8n08ig">
                      {bulkSelectedSkills.length > 0 ? `${bulkSelectedSkills.length} Skills selected` : 'Assign Skills...'}
                    </span>
                    <ChevronDown size={16} className={`text-gray-400 transition-transform flex-shrink-0 ml-2 ${isBulkSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-3390" data-mp="1khoenponhgf2" />
                  </button>

                  {isBulkSkillDropdownOpen && <div className="absolute bottom-full mb-2 left-0 w-full sm:w-80 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden z-50" data-id="element-3391" data-mp="21mht180hl3x6">
                      <div className="max-h-80 overflow-y-auto" data-id="element-3392" data-mp="2bit4xww5zrr3">
                        <p className="border-b border-gray-100 bg-[#30718D]/5 px-4 py-2 text-xs font-medium text-[#236B8C]" data-id="element-3393" data-mp="2bh9qmbu2jqry">
                          Assigning to {selectedLearnerLabel}
                        </p>
                        <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-3394" data-mp="2z8x67xlvrfex">
                          <span className="text-xs font-medium text-gray-900" data-id="element-3395" data-mp="2u9arfjqelr40">
                            Individual Skills
                          </span>
                          <button onClick={() => toggleBulkSkill('all')} className="text-xs font-medium text-[#30718D] hover:text-[#265a70]" data-id="element-3396" data-mp="14x0dm1bpc3ia">
                            {bulkSelectedSkills.length === availableSkills.length ? 'Deselect all' : 'Select all'}
                          </button>
                        </div>
                        {availableSkills.map(skill => <label key={skill} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0" data-id="element-3397" data-mp="31u4vr3p4zarg">
                            <input type="checkbox" checked={bulkSelectedSkills.includes(skill)} onChange={() => toggleBulkSkill(skill)} className="w-4 h-4 rounded border-gray-300 text-[#30718D] focus:ring-[#30718D]" data-id="element-3398" data-mp="2ssooh4tmborg" />
                            <span className="text-sm text-gray-700" data-id="element-3399" data-mp="2iv0r074mo35l">
                              {skill}
                            </span>
                          </label>)}
                      </div>
                    </div>}
                </div>

                {/* Assign Pathways Dropdown */}
                <div className="relative flex-1 sm:max-w-[240px]" ref={bulkPathwayDropdownRef} data-id="element-3400" data-mp="m2qvtftl4pnu">
                  <button onClick={() => {
                if (noLicensesAvailable) {
                  setShowNoLicenseToast(true);
                  setTimeout(() => setShowNoLicenseToast(false), 3000);
                  return;
                }
                setIsBulkPathwayDropdownOpen(!isBulkPathwayDropdownOpen);
                setIsBulkSkillDropdownOpen(false);
              }} className={`w-full px-4 py-2 border rounded-lg flex items-center justify-between text-sm ${noLicensesAvailable ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed' : isBulkPathwayDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 bg-white' : 'border-gray-300 hover:border-gray-400 bg-white'}`} data-id="element-3401" data-mp="1nudgiafop8xp">
                    <span className="truncate text-gray-700" data-id="element-3402" data-mp="2li5bqyv6m02n">
                      {bulkSelectedPathways.length > 0 ? `${bulkSelectedPathways.length} Pathways selected` : 'Assign Pathways...'}
                    </span>
                    <ChevronDown size={16} className={`text-gray-400 transition-transform flex-shrink-0 ml-2 ${isBulkPathwayDropdownOpen ? 'rotate-180' : ''}`} data-id="element-3403" data-mp="r4dw9iq68lza" />
                  </button>

                  {isBulkPathwayDropdownOpen && <div className="absolute bottom-full mb-2 left-0 w-full sm:w-80 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden z-50" data-id="element-3404" data-mp="es22o7ys2q6p">
                      <div className="max-h-80 overflow-y-auto" data-id="element-3405" data-mp="4vyqe9a7pb61">
                        <p className="border-b border-gray-100 bg-[#30718D]/5 px-4 py-2 text-xs font-medium text-[#236B8C]" data-id="element-3406" data-mp="4tclkheph9ri">
                          Assigning to {selectedLearnerLabel}
                        </p>
                        <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-3407" data-mp="skhzus4zztzp">
                          <span className="text-xs font-medium text-gray-900" data-id="element-3408" data-mp="nmgicbn802qc">
                            Pathways
                          </span>
                          <button onClick={() => toggleBulkPathway('all')} className="text-xs font-medium text-[#30718D] hover:text-[#265a70]" data-id="element-3409" data-mp="3d8wax5c9a81a">
                            {bulkSelectedPathways.length === pathwayData.map(p => p.name).length ? 'Deselect all' : 'Select all'}
                          </button>
                        </div>
                        {pathwayData.map(pathway => <label key={pathway.name} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100" data-id="element-3410" data-mp="1qdhlnue21bsf">
                            <input type="checkbox" checked={bulkSelectedPathways.includes(pathway.name)} onChange={() => toggleBulkPathway(pathway.name)} className="w-4 h-4 rounded border-gray-300 text-[#30718D] focus:ring-[#30718D]" data-id="element-3411" data-mp="1gopwfu0dp5l7" />
                            <div data-id="element-3412" data-mp="17p2un73qlxrm">
                              <div className="text-sm font-bold text-gray-900" data-id="element-3413" data-mp="17lou84emvymt">
                                {pathway.name}
                              </div>
                              <div className="text-xs text-gray-500" data-id="element-3414" data-mp="xqwtwsto2xoc">
                                {pathway.skillCount} skills
                              </div>
                            </div>
                          </label>)}
                      </div>
                    </div>}
                </div>
              </div>

              {/* Right side: Cancel + Assign */}
              <div className="flex items-center justify-center lg:justify-end gap-3" data-id="element-3415" data-mp="t1m324f3k4zp">
                <button onClick={() => {
              setSelectedUsers([]);
              setBulkSelectedSkills([]);
              setBulkSelectedPathways([]);
            }} className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-3416" data-mp="o29dhbwucjtf">
                  Cancel
                </button>
                <button onClick={() => {
              if (noLicensesAvailable) {
                setShowNoLicenseToast(true);
                setTimeout(() => setShowNoLicenseToast(false), 3000);
                return;
              }
              handleBulkAssign();
            }} disabled={noLicensesAvailable || bulkSelectedSkills.length === 0 && bulkSelectedPathways.length === 0} className={`flex items-center gap-2 px-6 py-2 rounded-lg text-sm font-medium transition-colors shadow-sm ${noLicensesAvailable ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : bulkSelectedSkills.length > 0 || bulkSelectedPathways.length > 0 ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-3417" data-mp="1brtzy4s7dz7g">
                  <CheckCircle size={16} data-id="element-3418" data-mp="3oxiis38s6ywy" />
                  Assign to {selectedLearnerLabel}
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}